(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[119],{

/***/ 18321:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var CHEVRON_DOWN = 'M7 10.1456L12 15L17 10.1456L15.82 9L12 12.7282L8.18 9L7 10.1456Z';
var IconChevronDown = lib.variant('IconChevronDown', icon.Icon, {
    path: CHEVRON_DOWN,
});

exports.IconChevronDown = IconChevronDown;
//# sourceMappingURL=_icon-chevrondown.js.map


/***/ }),

/***/ 22:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var DISLIKE_FILLED = 'M10.2353 20L9.35294 19.1367C9.13072 18.9193 9.01961 18.6443 9.01961 18.3117L9.01961 18.0432L9.82353 14.3789L4.64706 14.3789C4.20261 14.3789 3.817 14.2254 3.4902 13.9185C3.1634 13.6115 3 13.2406 3 12.8058L3.03922 12.729L3 12.729L3 11.1942C3 10.9896 3.03922 10.7914 3.11765 10.5995L5.60784 4.97842C5.71242 4.68425 5.90196 4.44764 6.17647 4.26858C6.45098 4.08953 6.75817 4 7.09804 4L14.451 4C14.8954 4 15.281 4.15987 15.6078 4.47962C15.9346 4.79936 16.098 5.17666 16.098 5.61151L16.098 13.5923C16.098 14.0016 15.9346 14.3789 15.6078 14.7242L10.2353 20ZM17.7059 13.5923L17.7059 4L21 4L21 13.5923L17.7059 13.5923Z';
var IconDislikeFilled = lib.variant('IconDislikeFilled', icon.Icon, {
    path: DISLIKE_FILLED,
});

exports.IconDislikeFilled = IconDislikeFilled;
//# sourceMappingURL=_icon-dislikefilled.js.map


/***/ }),

/***/ 11203:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var DISLIKE_OUTLINED = 'M10.2353 20L9.35294 19.1367C9.13072 18.9193 9.01961 18.6443 9.01961 18.3118V18.0432L9.82353 14.3789H4.64706C4.20261 14.3789 3.81699 14.2254 3.4902 13.9185C3.1634 13.6115 3 13.2406 3 12.8058L3.03922 12.729H3V11.1942C3 10.9896 3.03921 10.7914 3.11765 10.5995L5.60784 4.97842C5.71242 4.68425 5.90196 4.44764 6.17647 4.26859C6.45098 4.08953 6.75817 4 7.09804 4H14.451C14.8954 4 15.281 4.15987 15.6078 4.47962C15.9346 4.79936 16.098 5.17666 16.098 5.61151V13.5923C16.098 14.0016 15.9346 14.3789 15.6078 14.7242L10.2353 20ZM17.7059 13.5923V4H21V13.5923H17.7059ZM10.6725 17.5011L14.5027 13.7408C14.568 13.6717 14.5899 13.6377 14.596 13.6112L14.598 13.5923V5.61151C14.598 5.57585 14.5955 5.56103 14.5727 5.53478L14.5424 5.50352C14.5061 5.46794 14.4949 5.45818 14.475 5.45553L7.09804 5.45455L7.05317 5.45786L7.03705 5.46275V5.46275L7.01775 5.47345L6.98605 5.55253L4.51207 11.1356L4.50272 11.1652L4.5 11.1942V12.3927L4.50165 12.4006C4.53184 12.5251 4.54529 12.6543 4.54001 12.7852L4.53375 12.8735C4.57043 12.9081 4.58639 12.9194 4.61416 12.9229L4.64706 12.9244H9.82353C10.7409 12.9244 11.4341 13.7124 11.3096 14.5774L11.2907 14.6816L10.6725 17.5011Z';
var IconDislikeOutlined = lib.variant('IconDislikeOutlined', icon.Icon, {
    path: DISLIKE_OUTLINED,
});

exports.IconDislikeOutlined = IconDislikeOutlined;
//# sourceMappingURL=_icon-dislikeoutlined.js.map


/***/ }),

/***/ 33081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var EDIT = 'M20.712 7.032L18.888 8.856L15.144 5.112L16.968 3.288C17.16 3.096 17.396 3 17.676 3C17.956 3 18.192 3.096 18.384 3.288L20.712 5.616C20.904 5.808 21 6.044 21 6.324C21 6.604 20.904 6.84 20.712 7.032ZM3 17.256L14.064 6.192L17.808 9.936L6.744 21H3V17.256Z';
var IconEdit = lib.variant('IconEdit', icon.Icon, {
    path: EDIT,
});

exports.IconEdit = IconEdit;
//# sourceMappingURL=_icon-edit.js.map


/***/ }),

/***/ 3901:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var LIKE_OUTLINED = 'M13.7647 4L14.6471 4.86331C14.8693 5.08074 14.9804 5.35571 14.9804 5.68825V5.95683L14.1765 9.6211H19.3529C19.7974 9.6211 20.183 9.77458 20.5098 10.0815C20.8366 10.3885 21 10.7594 21 11.1942L20.9608 11.271H21V12.8058C21 13.0104 20.9608 13.2086 20.8824 13.4005L18.3922 19.0216C18.2876 19.3157 18.098 19.5524 17.8235 19.7314C17.549 19.9105 17.2418 20 16.902 20H9.54902C9.10457 20 8.71895 19.8401 8.39216 19.5204C8.06536 19.2006 7.90196 18.8233 7.90196 18.3885V10.4077C7.90196 9.9984 8.06536 9.6211 8.39216 9.27578L13.7647 4ZM6.29412 10.4077V20H3V10.4077H6.29412ZM13.3275 6.49891L9.49733 10.2592C9.43197 10.3283 9.41015 10.3623 9.40404 10.3888L9.40196 10.4077V18.3885C9.40196 18.4242 9.40452 18.439 9.42733 18.4652L9.45756 18.4965C9.49392 18.5321 9.50509 18.5418 9.52497 18.5445L9.54902 18.5455H16.902L16.9468 18.5421C16.9526 18.5409 16.9579 18.5393 16.963 18.5373L16.9823 18.5265L17.0139 18.4475L19.4879 12.8644L19.4973 12.8348L19.5 12.8058V11.6073L19.4983 11.5994C19.4682 11.4749 19.4547 11.3457 19.46 11.2148L19.4662 11.1265C19.4296 11.0919 19.4136 11.0806 19.3858 11.0771L19.3529 11.0756H14.1765C13.2591 11.0756 12.5659 10.2876 12.6904 9.42256L12.7093 9.31843L13.3275 6.49891Z';
var IconLikeOutlined = lib.variant('IconLikeOutlined', icon.Icon, {
    path: LIKE_OUTLINED,
});

exports.IconLikeOutlined = IconLikeOutlined;
//# sourceMappingURL=_icon-likeoutlined.js.map


/***/ }),

/***/ 46503:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(18321);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.C = index.IconChevronDown;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 85501:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(22);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.h = index.IconDislikeFilled;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 74592:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(11203);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.R = index.IconDislikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 56662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(33081);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.y = index.IconEdit;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 49816:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(3901);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.q = index.IconLikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 93501:
/***/ ((module) => {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 72340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 93719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 30404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 91348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 30375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 52506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838),
    isPrototype = __webpack_require__(92963),
    nativeKeysIn = __webpack_require__(10814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 97254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    assignMergeValue = __webpack_require__(72340),
    baseFor = __webpack_require__(91030),
    baseMergeDeep = __webpack_require__(10715),
    isObject = __webpack_require__(36838),
    keysIn = __webpack_require__(37390),
    safeGet = __webpack_require__(72014);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 10715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignMergeValue = __webpack_require__(72340),
    cloneBuffer = __webpack_require__(39767),
    cloneTypedArray = __webpack_require__(27136),
    copyArray = __webpack_require__(47165),
    initCloneObject = __webpack_require__(36404),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLikeObject = __webpack_require__(57348),
    isBuffer = __webpack_require__(61563),
    isFunction = __webpack_require__(92042),
    isObject = __webpack_require__(36838),
    isPlainObject = __webpack_require__(69143),
    isTypedArray = __webpack_require__(73806),
    safeGet = __webpack_require__(72014),
    toPlainObject = __webpack_require__(85111);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 5125:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__(48148),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var constant = __webpack_require__(64806),
    defineProperty = __webpack_require__(34082),
    identity = __webpack_require__(48148);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 78925:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Uint8Array = __webpack_require__(92210);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 39767:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 27136:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 47165:
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 92434:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__(93719),
    baseAssignValue = __webpack_require__(30404);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 77991:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRest = __webpack_require__(5125),
    isIterateeCall = __webpack_require__(97616);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 29:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 34082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 11389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 36404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    getPrototype = __webpack_require__(11389),
    isPrototype = __webpack_require__(92963);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 97616:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448),
    isArrayLike = __webpack_require__(47428),
    isIndex = __webpack_require__(91010),
    isObject = __webpack_require__(36838);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 10814:
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 20323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__(93501);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 72014:
/***/ ((module) => {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 71564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSetToString = __webpack_require__(56447),
    shortOut = __webpack_require__(15509);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 15509:
/***/ ((module) => {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 64806:
/***/ ((module) => {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(30375),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 57348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428),
    isObjectLike = __webpack_require__(55073);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 69143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    getPrototype = __webpack_require__(11389),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 37390:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeysIn = __webpack_require__(52506),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 53954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__(97254),
    createAssigner = __webpack_require__(77991);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 85111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 82951:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13923);

var ReviewPrompt = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "reviews";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | reviews */ 912).then(__webpack_require__.bind(__webpack_require__, 40617));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(40617);
        }
        return eval("require.resolve")("./prompt");
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReviewPrompt);


/***/ }),

/***/ 62539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ report)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(68456);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(64966);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/modal/confirm.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  h2 {\n    font-size: ",
        ";\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  .pj-ui-text-input {\n    margin-bottom: 0;\n  }\n\n  p {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: flex-end;\n  width: 100%;\n  button {\n    white-space: nowrap;\n    margin-left: ",
        ";\n    flex: 1;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(_templateObject());
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/modal/confirm.js
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var ConfirmModal = function(_param) {
    var onCancel = _param.onCancel, onConfirm = _param.onConfirm, hideModal = _param.hideModal, props = _objectWithoutProperties(_param, [
        "onCancel",
        "onConfirm",
        "hideModal"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: props.id,
        isOpen: props.isOpen,
        width: props.width,
        onRequestClose: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, /*#__PURE__*/ react.createElement(Content, null, props.title && /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement("h2", null, props.title)), /*#__PURE__*/ react.createElement(Body, null, props.children), /*#__PURE__*/ react.createElement(Footer, null, props.showCancel && /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "primary",
        variant: "outlined",
        onClick: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, props.cancelLabel || t("common", "button.cancel")), /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "positive",
        onClick: function() {
            return onConfirm === undefined ? hideModal() : onConfirm();
        }
    }, props.confirmLabel || t("common", "button.ok")))));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool, node = (prop_types_default()).node, number = (prop_types_default()).number;
ConfirmModal.propTypes = {
    hideModal: func.isRequired,
    onConfirm: func,
    onCancel: func,
    children: node,
    width: number,
    id: string,
    isOpen: bool,
    title: string,
    showCancel: bool,
    confirmLabel: string,
    cancelLabel: string
};
ConfirmModal.defaultProps = {
    onConfirm: undefined,
    onCancel: undefined,
    children: null,
    width: 400,
    id: undefined,
    isOpen: false,
    title: undefined,
    showCancel: false,
    confirmLabel: undefined,
    cancelLabel: undefined
};
/* harmony default export */ const modal_confirm = ((0,es/* connect */.$j)(null, actions/* default */.ZP)(/*#__PURE__*/ (0,react.memo)(ConfirmModal)));

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var reviews_actions = __webpack_require__(93302);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(31127);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
;// CONCATENATED MODULE: ./src/areas/reviews/components/report/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}










var ReportReviewModal = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(ReportReviewModal, _PureComponent);
    var _super = _createSuper(ReportReviewModal);
    function ReportReviewModal(props) {
        _classCallCheck(this, ReportReviewModal);
        var _this;
        _this = _super.call(this, props);
        _this.state = _this.getInitialState();
        return _this;
    }
    _createClass(ReportReviewModal, [
        {
            // eslint-disable-next-line class-methods-use-this
            key: "getInitialState",
            value: function getInitialState() {
                return {
                    errors: {},
                    message: "",
                    email: ""
                };
            }
        },
        {
            key: "sendReport",
            value: function sendReport(data) {
                var reviewId = data ? data.review : null;
                var errors = {
                    message: typeof data.message !== "string" || !data.message.trim().length,
                    email: typeof data.email !== "string" || !(0,helpers/* isValidEmail */.vV)(data.email)
                };
                if (errors.message || errors.email) {
                    this.setState({
                        errors: errors
                    });
                } else {
                    if (this.props.type === "product") {
                        (0,tracking/* productReviewReported */.mC)();
                    }
                    if (this.props.type === "store") {
                        (0,tracking/* storeReviewReported */.gK)();
                    }
                    this.props.reportReview(reviewId, data.message, data.email);
                    this.close();
                }
            }
        },
        {
            key: "close",
            value: function close() {
                this.props.onComplete();
                this.setState(this.getInitialState());
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                var errors = this.state.errors;
                var account = this.props.account;
                var email = account && account.me ? account.me.email : false;
                return /*#__PURE__*/ react.createElement(modal_confirm, {
                    isOpen: !!this.props.review,
                    showCancel: true,
                    confirmLabel: t("feedback", "report-review.send-button"),
                    title: t("feedback", "report-review.title"),
                    onCancel: function() {
                        return _this.close();
                    },
                    onConfirm: function() {
                        _this.sendReport({
                            review: _this.props.review,
                            message: _this.state.message,
                            email: email !== false ? email : _this.state.email
                        });
                    }
                }, /*#__PURE__*/ react.createElement(inputs/* TextArea */.Kx, {
                    onChange: function(e) {
                        return _this.setState({
                            message: e.target.value
                        });
                    },
                    name: "message",
                    label: t("feedback", "report-review.message-label"),
                    tabIndex: "0",
                    warning: !!errors.message,
                    helper: !errors.message ? t("feedback", "report-review.message-helper") : t("feedback", "error.field-is-required")
                }), !email && /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
                    onChange: function(e) {
                        return _this.setState({
                            email: e.target.value
                        });
                    },
                    name: "email",
                    label: t("feedback", "report-review.email-label"),
                    type: "email",
                    tabIndex: "0",
                    warning: !!errors.email,
                    helper: errors.email ? t("feedback", "error.field-is-required") : t("feedback", "report-review.email-helper")
                }));
            }
        }
    ]);
    return ReportReviewModal;
}(react.PureComponent);
ReportReviewModal.propTypes = {
    showModal: (prop_types_default()).func.isRequired,
    hideModal: (prop_types_default()).func.isRequired,
    reportReview: (prop_types_default()).func.isRequired,
    onComplete: (prop_types_default()).func.isRequired,
    account: prop_types_default().shape({
        me: (prop_types_default()).object
    }),
    review: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ]),
    type: prop_types_default().oneOf([
        "product",
        "store"
    ]).isRequired
};
ReportReviewModal.defaultProps = {
    account: {
        me: undefined
    },
    review: undefined
};
ReportReviewModal.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const report = ((0,es/* connect */.$j)(function(state) {
    return {
        account: state.areas.account
    };
}, _objectSpread({}, actions/* default */.ZP, reviews_actions/* default */.ZP))(ReportReviewModal));


/***/ }),

/***/ 96833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ storeLinkClick)
/* harmony export */ });
var storeLinkClick = function(store) {
    return {
        type: "STORE_LINK_CLICK",
        store: store
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    storeLinkClick: storeLinkClick
});


/***/ }),

/***/ 51961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ ExpandableGrid)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(46503);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(65451);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/expandable-grid/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        grid-template-columns: repeat(3, 1fr);\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        grid-template-columns: repeat(2, 1fr);\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: ",
        ";\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding-top: 10px;\n  padding-bottom: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ItemContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ItemContainer",
    componentId: "sc-0-0"
})(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), function(props) {
    return props.$cssGrid && (0,styled_components_browser_esm.css)(_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject1()), base/* media.smallOnly */.BC.smallOnly(_templateObject2()));
});
var ActionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ActionsContainer",
    componentId: "sc-0-1"
})(_templateObject5());
var ToggleContainer = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ToggleContainer"
}).withConfig({
    displayName: "ToggleContainer",
    componentId: "sc-0-2"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/expandable-grid/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






var ExpandableGrid = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ExpandableGrid, _Component);
    var _super = _createSuper(ExpandableGrid);
    function ExpandableGrid(props) {
        _classCallCheck(this, ExpandableGrid);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            expanded: _this.props.ssrExpanded
        };
        _this.expand = _this.expand.bind(_assertThisInitialized(_this));
        _this.collapse = _this.collapse.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(ExpandableGrid, [
        {
            key: "expand",
            value: function expand() {
                this.setState({
                    expanded: true
                });
                this.props.onExpand();
            }
        },
        {
            key: "collapse",
            value: function collapse() {
                this.setState({
                    expanded: false
                });
                this.props.onCollapse();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.ssrExpanded) {
                    this.collapse();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, expandText = _props.expandText, collapseText = _props.collapseText, items = _props.items, limit = _props.limit, expandedActions = _props.expandedActions, showArrow = _props.showArrow, canCollapse = _props.canCollapse, cssGrid = _props.cssGrid;
                var expanded = this.state.expanded;
                if (!items || items.length === 0) {
                    return null;
                }
                var needButton = limit < items.length && (!expanded || canCollapse);
                var itemsToDisplay = expanded ? items : items.slice(0, limit);
                return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(ItemContainer, {
                    $cssGrid: cssGrid
                }, itemsToDisplay), expanded && expandedActions && /*#__PURE__*/ react.createElement(ActionsContainer, null, expandedActions), needButton && /*#__PURE__*/ react.createElement(ToggleContainer, null, /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
                    iconPosition: "bottom",
                    variant: "text",
                    color: "link",
                    size: "medium",
                    icon: // eslint-disable-next-line  no-nested-ternary
                    showArrow ? this.state.expanded ? /*#__PURE__*/ react.createElement(chevron_up/* IconChevronUp */.y, null) : /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null) : null,
                    onClick: this.state.expanded ? this.collapse : this.expand
                }, /*#__PURE__*/ react.createElement("span", null, this.state.expanded ? collapseText : expandText))));
            }
        }
    ]);
    return ExpandableGrid;
}(react.Component);
var number = (prop_types_default()).number, arrayOf = (prop_types_default()).arrayOf, expandable_grid_element = (prop_types_default()).element, func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool, node = (prop_types_default()).node;
ExpandableGrid.propTypes = {
    limit: number.isRequired,
    items: arrayOf(expandable_grid_element).isRequired,
    expandText: string.isRequired,
    collapseText: string.isRequired,
    showArrow: bool,
    canCollapse: bool,
    expandedActions: node,
    onExpand: func,
    onCollapse: func,
    cssGrid: bool,
    ssrExpanded: bool,
    onClick: func
};
ExpandableGrid.defaultProps = {
    showArrow: true,
    canCollapse: true,
    expandedActions: null,
    onExpand: function() {},
    onCollapse: function() {},
    ssrExpanded: false,
    onClick: function() {}
};


/***/ }),

/***/ 79744:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ useSotyState),
/* harmony export */   "P": () => (/* binding */ SotyState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3732);


var SotyState;
(function(SotyState) {
    SotyState["PROMO"] = "promo";
    SotyState["ACTIVE"] = "active";
    SotyState["FINISHED"] = "finished";
})(SotyState || (SotyState = {}));
var selectCampaignBanners = function(state) {
    return state.globals.campaignBanners;
};
var useSotyState = function() {
    var campaignBanners = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(selectCampaignBanners);
    var sotyState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var banner = campaignBanners.active.find(function(b) {
            return b.campaign.type === "SOTY";
        });
        switch(banner === null || banner === void 0 ? void 0 : banner.type){
            case "SOTY_PROMO":
                return SotyState.PROMO;
            case "SOTY_FINISHED":
                return SotyState.FINISHED;
            case "SOTY_ACTIVE":
                return SotyState.ACTIVE;
            default:
                return "";
        }
    }, [
        campaignBanners.active
    ]);
    return sotyState;
};


/***/ }),

/***/ 56132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ useReviewContext),
/* harmony export */   "b": () => (/* binding */ ReviewContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

var initialValue = {
    onReviewExpansion: undefined
};
var ReviewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useReviewContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReviewContext);
};
var ReviewContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReviewContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 83724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ store)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(58079);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/areas/store/actions/index.js
var actions = __webpack_require__(96833);
// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/index.tsx + 1 modules
var sticky_tab_nav = __webpack_require__(30734);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(90243);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(32401);
// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(55549);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/index.tsx + 1 modules
var smiley_rating = __webpack_require__(1489);
// EXTERNAL MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/index.tsx + 1 modules
var soty_badge = __webpack_require__(91285);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SotyBadge = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "SotyBadge",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/index.tsx




var SotyBadgeLink = function(param) {
    var className = param.className, size = param.size, sotyBadge = param.sotyBadge;
    var ref;
    var linkTo = (0,react.useContext)(app_context/* AppContext */.Il).linkTo;
    var sotyLink = linkTo("shopOfTheYearWinners", {
        year: sotyBadge.year
    });
    return /*#__PURE__*/ react.createElement(SotyBadge, {
        to: sotyLink,
        className: className
    }, sotyBadge.logo && /*#__PURE__*/ react.createElement(soty_badge/* SotyBadge */.L, {
        imgUrl: sotyBadge.logo,
        name: sotyBadge.name,
        size: size,
        year: (ref = sotyBadge.year) === null || ref === void 0 ? void 0 : ref.toString()
    }));
};
/* harmony default export */ const soty_badge_link = (SotyBadgeLink);

;// CONCATENATED MODULE: ./src/areas/store/components/store-link/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StoreLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StoreLink",
    componentId: "sc-0-0"
})(styles_templateObject(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.callToActionHover;
});

;// CONCATENATED MODULE: ./src/areas/store/components/store-link/index.tsx


var store_link_StoreLink = function(param) {
    var store = param.store, storeLinkClick = param.storeLinkClick;
    var ref;
    if (!store.externalUri) return null;
    var text = (ref = store.externalUriText) === null || ref === void 0 ? void 0 : ref.split("/")[0];
    return /*#__PURE__*/ react.createElement(StoreLink, {
        onClick: function() {
            return storeLinkClick({
                id: store.id,
                name: store.name,
                featured: Boolean(store.featured),
                userReviewSummary: store.userReviewSummary
            });
        },
        // eslint-disable-next-line react/jsx-no-target-blank
        target: "_BLANK",
        rel: "nofollow noopener",
        href: store.externalUri
    }, text);
};
/* harmony default export */ const store_link = (store_link_StoreLink);

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(70477);
// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(26474);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/info-list/index.tsx + 1 modules
var info_list = __webpack_require__(37571);
;// CONCATENATED MODULE: ./src/areas/store/components/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    @supports (display: grid) {\n      grid-template-columns: 1fr auto;\n    }\n  "
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: ",
        ";\n  padding-bottom: ",
        ";\n\n  @supports (display: grid) {\n    display: grid;\n    grid-template-columns: 1fr 30%;\n    row-gap: ",
        ";\n    column-gap: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = header_styles_taggedTemplateLiteral([
        "\n        &:first-child:before {\n          display: none;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = header_styles_taggedTemplateLiteral([
        "\n        &:first-child {\n          width: 100%;\n          margin: 0;\n          margin-bottom: ",
        ";\n        }\n\n        &:not(:last-child)::before {\n          display: none;\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: ",
        ";\n\n    li {\n      display: flex;\n      align-items: center;\n      margin-right: ",
        ";\n\n      &:last-child {\n        margin: 0;\n      }\n\n      &::before {\n        content: '|';\n        margin-right: ",
        ";\n        color: ",
        ";\n      }\n\n      ",
        "\n\n      ",
        "\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin: 0;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 50%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = header_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    margin: 0 0 0 ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  @supports (display: grid) {\n    grid-area: 2 / 1 / 3 / 3;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}





var Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(header_styles_templateObject()));
var TitleWrapper = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.theme.lines.secondary, base/* media.mediumUp */.BC.mediumUp(_templateObject2()), base/* media.smallOnly */.BC.smallOnly(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
});
var Title = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject5(), (0,base/* remCalc */.vR)(constants/* MAIN_TITLE_SIZE */.XZ), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-3"
})(_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), constants/* mobileLogoWidth */.v4));
var StoreInfoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfoWrapper",
    componentId: "sc-0-4"
})(_templateObject8());
var TitleAndLogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleAndLogoWrapper",
    componentId: "sc-0-5"
})(_templateObject9());
var CountryText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CountryText",
    componentId: "sc-0-6"
})(_templateObject10());
var RatingCount = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RatingCount",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject11(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.quaternary);
});
var InfoList = (0,styled_components_browser_esm["default"])(info_list/* InfoList */.Q).withConfig({
    displayName: "InfoList",
    componentId: "sc-0-8"
})(_templateObject12());
var SotyBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SotyBadgeWrapper",
    componentId: "sc-0-9"
})(_templateObject13());

;// CONCATENATED MODULE: ./src/areas/store/components/header/index.tsx










var header_Header = function(param) {
    var store = param.store, sotyBadge = param.sotyBadge, storeLinkClick = param.storeLinkClick;
    var isMobile = (0,react.useContext)(context/* default */.ZP).isMobile;
    var renderTitleAndLogo = function() {
        return /*#__PURE__*/ react.createElement(TitleAndLogoWrapper, null, store.featured && /*#__PURE__*/ react.createElement(StoreLogo, {
            logoUrl: store.logo,
            name: store.name,
            storeId: store.id,
            featured: store.featured,
            hasImage: Boolean(store.hasLogo),
            variant: store_logo/* StoreLogoVariant.HEADING */.mA.HEADING,
            width: store.logo ? constants/* SHOP_LOGO_WIDTH */.L9 : undefined
        }), /*#__PURE__*/ react.createElement(TitleWrapper, null, /*#__PURE__*/ react.createElement("li", null, /*#__PURE__*/ react.createElement(Title, null, store.name), !!store.userReviewSummary.rating && store.userReviewSummary.count !== 0 && /*#__PURE__*/ react.createElement(smiley_rating/* default */.Z, {
            featured: Boolean(store.featured),
            rating: rating_helper/* default.convert */.Z.convert(store.userReviewSummary.rating),
            reviewCount: store.userReviewSummary.countTotal,
            scoreVisibility: "row",
            size: "small"
        })), /*#__PURE__*/ react.createElement("li", null, /*#__PURE__*/ react.createElement(country_flag/* CountryFlag */.A, {
            countryCode: store.countryCode,
            showTitleAsTooltip: false,
            title: store.countryCode
        }), /*#__PURE__*/ react.createElement(CountryText, null, store.countryCode)), store.externalUri && store.featured && /*#__PURE__*/ react.createElement("li", null, /*#__PURE__*/ react.createElement(store_link, {
            store: store,
            storeLinkClick: storeLinkClick
        }))));
    };
    var renderGeneralInfo = function() {
        var ref;
        return store.featured && ((ref = store.providedByStore) === null || ref === void 0 ? void 0 : ref.generalInformation) ? /*#__PURE__*/ react.createElement(InfoList, {
            list: store.providedByStore.generalInformation
        }) : null;
    };
    var renderSotyBadge = function() {
        return (sotyBadge === null || sotyBadge === void 0 ? void 0 : sotyBadge.logo) ? /*#__PURE__*/ react.createElement(SotyBadgeWrapper, null, /*#__PURE__*/ react.createElement(soty_badge_link, {
            sotyBadge: sotyBadge
        })) : null;
    };
    return /*#__PURE__*/ react.createElement(Header, null, isMobile ? /*#__PURE__*/ react.createElement(react.Fragment, null, renderTitleAndLogo(), renderSotyBadge(), renderGeneralInfo()) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StoreInfoWrapper, null, renderTitleAndLogo(), renderGeneralInfo()), renderSotyBadge()));
};
/* harmony default export */ const header = (header_Header);

;// CONCATENATED MODULE: ./src/areas/store/types.ts
var TabAnchor;
(function(TabAnchor) {
    TabAnchor["REVIEWS"] = "#reviews";
    TabAnchor["ABOUT"] = "#about";
})(TabAnchor || (TabAnchor = {}));

;// CONCATENATED MODULE: ./src/areas/store/components/notification/types.ts
var NotificationTypeEnum;
(function(NotificationTypeEnum) {
    NotificationTypeEnum["INFO"] = "info";
    NotificationTypeEnum["ISSUE"] = "issue";
    NotificationTypeEnum["NEUTRAL"] = "neutral";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));

// EXTERNAL MODULE: ./src/components/notification/types.ts
var types = __webpack_require__(65348);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/analytics/index.js
var analytics = __webpack_require__(14183);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(42779);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(77660);
// EXTERNAL MODULE: ./src/components/expandable-grid/index.js + 1 modules
var expandable_grid = __webpack_require__(51961);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(46422);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(44703);
// EXTERNAL MODULE: ./src/components/location-and-currency-info/index.tsx + 1 modules
var location_and_currency_info = __webpack_require__(22045);
;// CONCATENATED MODULE: ./src/areas/store/components/card/styles.ts
function card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function card_styles_templateObject() {
    var data = card_styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  position: relative;\n  outline: none;\n  padding: ",
        ";\n  ",
        "\n\n  &::before {\n    ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  @media (pointer: fine) {\n    &:hover::after,\n    &.focus-visible::after {\n      ",
        "\n    }\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  width: 100%;\n  min-height: 100%;\n  min-width: ",
        ";\n  max-width: ",
        ";\n  text-align: center;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  font-weight: 600;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = card_styles_taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: 600;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  display: flex;\n  justify-content: center;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = card_styles_taggedTemplateLiteral([
        "\n  width: 88px;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var sharedStyles = (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* layout.productCardPaddingSmall */.bK.productCardPaddingSmall, base/* media.mediumUp */.BC.mediumUp(card_styles_templateObject(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge), base/* styledUtils.overlay */.au.overlay());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(styles_templateObject2(), sharedStyles);
var Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(styles_templateObject3(), sharedStyles, base/* styledUtils.overlay */.au.overlay());
var Card = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Card",
    componentId: "sc-0-2"
})(styles_templateObject4(), base/* layout.productCardMinWidthMobile */.bK.productCardMinWidthMobile, base/* layout.productCardMaxWidth */.bK.productCardMaxWidth);
var styles_Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(styles_templateObject5());
var Subtitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject6(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.tertiary);
});
var sharedImageStyling = (0,styled_components_browser_esm.css)(styles_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_SotyBadge = (0,styled_components_browser_esm["default"])(soty_badge/* SotyBadge */.L).withConfig({
    displayName: "SotyBadge",
    componentId: "sc-0-5"
})(styles_templateObject8(), sharedImageStyling);
var Image = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-6"
})(styles_templateObject9(), sharedImageStyling);
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-7"
})(styles_templateObject10());

;// CONCATENATED MODULE: ./src/areas/store/components/card/index.tsx


var card_Card = function(param) {
    var className = param.className, imgUrl = param.imgUrl, year = param.year, title = param.title, link = param.link, _type = param.type, type = _type === void 0 ? "default" : _type, onClick = param.onClick;
    var renderCardImage = function() {
        if (!imgUrl) return null;
        return type === "soty" ? /*#__PURE__*/ react.createElement(styles_SotyBadge, {
            imgUrl: imgUrl,
            name: title,
            year: year
        }) : /*#__PURE__*/ react.createElement(Image, null, /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement("img", {
            src: imgUrl,
            alt: title,
            title: title
        })));
    };
    var renderCardContent = function() {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, renderCardImage(), /*#__PURE__*/ react.createElement(styles_Title, null, title), year && /*#__PURE__*/ react.createElement(Subtitle, null, year));
    };
    return /*#__PURE__*/ react.createElement(Card, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(Link, {
        to: link,
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    }, renderCardContent()) : /*#__PURE__*/ react.createElement(Content, null, renderCardContent()));
};
/* harmony default export */ const card = (card_Card);

;// CONCATENATED MODULE: ./src/areas/store/components/about-store/styles.ts
function about_store_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function about_store_styles_templateObject() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    about_store_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject1() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    about_store_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject2() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: 1fr;\n  "
    ]);
    about_store_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject3() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n\n  ",
        "\n"
    ]);
    about_store_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject4() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    about_store_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject5() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    about_store_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject6() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    about_store_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject7() {
    var data = about_store_styles_taggedTemplateLiteral([
        ""
    ]);
    about_store_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject8() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n      &:nth-child(",
        "n + 1) {\n        > * {\n          margin-left: 0;\n        }\n      }\n\n      &:nth-child(",
        "n + ",
        ") {\n        > * {\n          margin-right: 0;\n        }\n      }\n    "
    ]);
    about_store_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject9() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n      max-width: 50%;\n      margin-right: auto;\n\n      &:nth-child(2n + 1) {\n        > * {\n          margin-left: 0;\n        }\n      }\n\n      &:nth-child(2n + 2) {\n        > * {\n          margin-right: 0;\n        }\n      }\n    "
    ]);
    about_store_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function about_store_styles_templateObject10() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n    z-index: 1;\n\n    > * {\n      margin: ",
        ";\n    }\n\n    ",
        "\n\n    ",
        "\n\n    @media ",
        " {\n      max-width: 100%;\n\n      > * {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n  "
    ]);
    about_store_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = about_store_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin: ",
        " 0;\n  color: ",
        ";\n\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}







var styles_StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-0"
})(about_store_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var LocationAndCurrencyInfo = (0,styled_components_browser_esm["default"])(location_and_currency_info/* default */.Z).withConfig({
    displayName: "LocationAndCurrencyInfo",
    componentId: "sc-0-1"
})(about_store_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var GridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridWrapper",
    componentId: "sc-0-2"
})(about_store_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(about_store_styles_templateObject2()));
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-3"
})(about_store_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var about_store_styles_Title = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-4"
})(about_store_styles_templateObject5(), (0,base/* remCalc */.vR)(constants/* CONTENT_TITLE_SIZE */.QO), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Awards = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Awards",
    componentId: "sc-0-5"
})(about_store_styles_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AuthorizedDealers = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AuthorizedDealers",
    componentId: "sc-0-6"
})(about_store_styles_templateObject7());
var styles_Card = (0,styled_components_browser_esm["default"])(card).withConfig({
    displayName: "Card",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(about_store_styles_templateObject10(), "".concat(100 / props.limit, "%"), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeUp */.BC.largeUp(about_store_styles_templateObject8(), props.limit, props.limit, props.limit), base/* media.mediumDown */.BC.mediumDown(about_store_styles_templateObject9()), "screen and (max-width: 320px)");
});
var CheckIcon = (0,styled_components_browser_esm["default"])(check_filled/* IconCheckFilled */.i).attrs({
    color: "positive500"
}).withConfig({
    displayName: "CheckIcon",
    componentId: "sc-0-8"
})(styles_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var DeliveryOptionList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "DeliveryOptionList",
    componentId: "sc-0-9"
})(styles_templateObject12());
var DeliveryOption = styled_components_browser_esm["default"].li.withConfig({
    displayName: "DeliveryOption",
    componentId: "sc-0-10"
})(styles_templateObject13(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(props) {
    return props.theme.text.secondary;
}, CheckIcon, function(p) {
    return p.theme.colors.positive500;
});

// EXTERNAL MODULE: ./src/components/store-payment/utils.ts + 1 modules
var utils = __webpack_require__(6082);
;// CONCATENATED MODULE: ./src/areas/store/components/about-store/types.ts
var DeliveryOptionsTranslationEnum;
(function(DeliveryOptionsTranslationEnum) {
    DeliveryOptionsTranslationEnum["HOME_DELIVERY"] = "home-delivery";
})(DeliveryOptionsTranslationEnum || (DeliveryOptionsTranslationEnum = {}));

;// CONCATENATED MODULE: ./src/areas/store/components/about-store/payment/styles.ts
function payment_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function payment_styles_templateObject() {
    var data = payment_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  img {\n    max-height: 24px;\n    margin: ",
        ";\n  }\n"
    ]);
    payment_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function payment_styles_templateObject1() {
    var data = payment_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    payment_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function payment_styles_templateObject2() {
    var data = payment_styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n      text-decoration: line-through;\n\n      ",
        " {\n        path {\n          fill: ",
        ";\n        }\n      }\n    "
    ]);
    payment_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function payment_styles_templateObject3() {
    var data = payment_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    margin: ",
        " 0;\n    color: ",
        ";\n\n    ",
        " {\n      path {\n        fill: ",
        ";\n      }\n    }\n\n    ",
        "\n  "
    ]);
    payment_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function payment_styles_templateObject4() {
    var data = payment_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n"
    ]);
    payment_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var PaymentProviders = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PaymentProviders",
    componentId: "sc-0-0"
})(payment_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_CheckIcon = (0,styled_components_browser_esm["default"])(check_filled/* IconCheckFilled */.i).withConfig({
    displayName: "CheckIcon",
    componentId: "sc-0-1"
})(payment_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PaymentOption = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaymentOption",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(payment_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, props.theme.text.secondary, styles_CheckIcon, props.theme.colors.positive500, !props.active && (0,styled_components_browser_esm.css)(payment_styles_templateObject2(), props.theme.text.quaternary, styles_CheckIcon, props.theme.colors.base300));
});
var PaymentOptionList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "PaymentOptionList",
    componentId: "sc-0-3"
})(payment_styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/store/components/about-store/payment/payment-providers.tsx


var payment_providers_PaymentProviders = function(props) {
    return /*#__PURE__*/ react.createElement(PaymentProviders, null, props.providers.map(function(provider) {
        return Boolean(provider.active) && /*#__PURE__*/ react.createElement("img", {
            src: provider.logoUrl,
            alt: provider.label,
            title: provider.label,
            key: provider.name
        });
    }));
};
/* harmony default export */ const payment_providers = (payment_providers_PaymentProviders);

;// CONCATENATED MODULE: ./src/areas/store/components/about-store/payment/payment-options.tsx


var PaymentOptions = function(props) {
    return /*#__PURE__*/ react.createElement(PaymentOptionList, null, props.options.map(function(option) {
        return option && /*#__PURE__*/ react.createElement(PaymentOption, {
            active: Boolean(option.active),
            key: option.name
        }, /*#__PURE__*/ react.createElement(styles_CheckIcon, {
            size: 22
        }), option.translatedName);
    }));
};
/* harmony default export */ const payment_options = (PaymentOptions);

;// CONCATENATED MODULE: ./src/areas/store/components/about-store/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var cardLimit = 4;
var About = function(param) {
    var className = param.className, store = param.store, storeLinkClick = param.storeLinkClick;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref8.linkTo, t = ref8.t, market = ref8.market;
    var highResolutionLogo = store.logo ? {
        url: store.logo,
        width: constants/* SHOP_LOGO_WIDTH */.L9
    } : null;
    var getAwardItem = function(award, index) {
        var ref;
        if (!award || !award.name) return null;
        var to = linkTo("shopOfTheYearWinners", {
            year: award.year || ""
        });
        return /*#__PURE__*/ react.createElement(styles_Card, {
            key: award.name,
            imgUrl: award.logo,
            title: award.name,
            limit: cardLimit,
            year: (ref = award.year) === null || ref === void 0 ? void 0 : ref.toString(),
            link: to,
            type: "soty",
            onClick: function() {
                return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking_tracking/* InternalNavigationScope.STORE_AWARD_CARD */.U.STORE_AWARD_CARD,
                    nextPage: to,
                    index: index
                });
            }
        });
    };
    var getAuthorizedDealerItem = function(authorizedDealer, index) {
        if (!authorizedDealer.name) return null;
        var to = linkTo("brand", authorizedDealer);
        return /*#__PURE__*/ react.createElement(styles_Card, {
            imgUrl: authorizedDealer.logo,
            title: authorizedDealer.name,
            key: authorizedDealer.name,
            limit: cardLimit,
            link: linkTo("brand", authorizedDealer),
            onClick: function() {
                return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking_tracking/* InternalNavigationScope.AUTHORIZED_DEALER */.U.AUTHORIZED_DEALER,
                    nextPage: to,
                    index: index
                });
            }
        });
    };
    var paymentProviders = (0,utils/* getPaymentProviders */.Qk)(store, market);
    var paymentOptions = (0,utils/* getPaymentOptions */.V7)(store, t);
    var uniqueDeliveryOptions = _toConsumableArray(new Set(store.deliveryOptions || []));
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, store.featured ? /*#__PURE__*/ react.createElement(styles_StoreLogo, {
        name: store.name,
        storeId: store.id,
        featured: store.featured,
        hasImage: Boolean(store.hasLogo),
        logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
        width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width,
        showHighResolutionLogo: Boolean(highResolutionLogo)
    }) : null, /*#__PURE__*/ react.createElement(GridWrapper, null, /*#__PURE__*/ react.createElement(LocationAndCurrencyInfo, {
        countryCode: store.countryCode,
        countryName: store.countryName,
        currency: store.currency,
        id: store.id.toString(),
        marketplace: Boolean(store.marketplace),
        storeName: store.name
    })), /*#__PURE__*/ react.createElement(StoreInfo, null, Boolean(paymentOptions.hasOptions || paymentProviders.hasProviders) && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "store.payment-options")), paymentProviders.hasProviders ? /*#__PURE__*/ react.createElement(payment_providers, {
        providers: paymentProviders.providers
    }) : null, paymentOptions.hasOptions ? /*#__PURE__*/ react.createElement(payment_options, {
        options: paymentOptions.options
    }) : null), (uniqueDeliveryOptions === null || uniqueDeliveryOptions === void 0 ? void 0 : uniqueDeliveryOptions.length) ? /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "store.delivery-options")), /*#__PURE__*/ react.createElement(DeliveryOptionList, null, uniqueDeliveryOptions.map(function(option) {
        return option && /*#__PURE__*/ react.createElement(DeliveryOption, {
            key: option
        }, /*#__PURE__*/ react.createElement(CheckIcon, {
            size: 22
        }), t("store", "store.".concat(DeliveryOptionsTranslationEnum[option])));
    }))) : null, Boolean(store.supportTelephone || store.supportOnsite || ((ref = store.languages) === null || ref === void 0 ? void 0 : (ref1 = ref.support) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "store.contact")), ((ref2 = store.languages) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.support) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ react.createElement("p", null, t("store", "store.languages", {
        languages: store.languages.support.join(", ")
    })), store.supportTelephone && /*#__PURE__*/ react.createElement("p", null, t("store", "store.telephone-support")), store.supportOnsite && /*#__PURE__*/ react.createElement("p", null, t("store", "store.installation-support")), store.featured && store.externalUri && /*#__PURE__*/ react.createElement(store_link, {
        store: store,
        storeLinkClick: storeLinkClick
    })), Boolean(store.companyName || store.companyNumber || store.companyInfoUrl) && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "store.company-info")), store.companyName && /*#__PURE__*/ react.createElement("p", null, t("store", "store.company-name"), " ", store.companyName), store.companyNumber && /*#__PURE__*/ react.createElement("p", null, t("store", "store.company-number"), " ", store.companyNumber), store.featured && store.companyInfoUrl && /*#__PURE__*/ react.createElement("p", null, /*#__PURE__*/ react.createElement("span", null, t("store", "store.company-information-link")), " ", /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
        to: store.companyInfoUrl,
        isExternal: true
    }, t("store", "store.company-information-url"))))), ((ref4 = store.storeOfTheYearAwards) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ react.createElement(Awards, null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "shop-of-the-year.awards")), /*#__PURE__*/ react.createElement(expandable_grid/* ExpandableGrid */.i, {
        limit: cardLimit,
        expandText: t("common", "button.show-more"),
        collapseText: "",
        items: (ref5 = store.storeOfTheYearAwards) === null || ref5 === void 0 ? void 0 : ref5.map(getAwardItem),
        canCollapse: false
    })) : null, ((ref6 = store.authorizedBy) === null || ref6 === void 0 ? void 0 : ref6.length) ? /*#__PURE__*/ react.createElement(AuthorizedDealers, null, /*#__PURE__*/ react.createElement(about_store_styles_Title, null, t("store", "brand.recommended-retailer")), /*#__PURE__*/ react.createElement(expandable_grid/* ExpandableGrid */.i, {
        limit: cardLimit,
        expandText: t("common", "button.show-more"),
        collapseText: "",
        items: (ref7 = store.authorizedBy) === null || ref7 === void 0 ? void 0 : ref7.map(getAuthorizedDealerItem),
        canCollapse: false
    })) : null);
};
/* harmony default export */ const about_store = (About);

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/areas/store/components/notification/styles.ts
function notification_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function notification_styles_templateObject() {
    var data = notification_styles_taggedTemplateLiteral([
        ""
    ]);
    notification_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function notification_styles_templateObject1() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    notification_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function notification_styles_templateObject2() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n      padding: ",
        ";\n      background: ",
        ";\n      color: ",
        ";\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        &:not(:last-of-type) {\n          margin-bottom: ",
        ";\n        }\n      }\n    "
    ]);
    notification_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function notification_styles_templateObject3() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n\n      ",
        " {\n        display: flex;\n        justify-content: space-between;\n        color: ",
        ";\n        padding: ",
        ";\n\n        p {\n          margin: 0;\n          margin-right: ",
        ";\n        }\n\n        > svg {\n          margin: 0 ",
        ";\n        }\n      }\n    "
    ]);
    notification_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function notification_styles_templateObject4() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n      padding: ",
        ";\n      background: ",
        ";\n      color: ",
        ";\n\n      ",
        " {\n        color: ",
        ";\n      }\n\n      ",
        " {\n        &:not(:last-of-type) {\n          margin-bottom: ",
        ";\n        }\n      }\n    "
    ]);
    notification_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function notification_styles_templateObject5() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n    border-radius: 5px;\n\n    ",
        "\n\n    ",
        "\n\n      ",
        "\n  "
    ]);
    notification_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function notification_styles_templateObject6() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin-bottom: ",
        ";\n"
    ]);
    notification_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function notification_styles_templateObject7() {
    var data = notification_styles_taggedTemplateLiteral([
        ""
    ]);
    notification_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function notification_styles_templateObject8() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  max-width: 650px;\n  margin: 0;\n"
    ]);
    notification_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function notification_styles_templateObject9() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  &::after {\n    content: '|';\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    notification_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function notification_styles_templateObject10() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    notification_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function notification_styles_templateObject11() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    notification_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function notification_styles_templateObject12() {
    var data = notification_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n"
    ]);
    notification_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var notification_styles_Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(notification_styles_templateObject());
var Message = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-1"
})(notification_styles_templateObject1());
var Notification = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Notification",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(notification_styles_templateObject5(), props.type === NotificationTypeEnum.ISSUE && (0,styled_components_browser_esm.css)(notification_styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, props.theme.notifications.issue.bg, props.theme.notifications.issue.fg, notification_styles_Title, props.theme.notifications.issue.fg, Message, base/* layout.measurements.spacing100 */.bK.measurements.spacing100), props.type === NotificationTypeEnum.INFO && (0,styled_components_browser_esm.css)(notification_styles_templateObject3(), props.theme.notifications.info.bg, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.notifications.info.fg, Message, props.theme.notifications.info.fg, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), props.type === NotificationTypeEnum.NEUTRAL && (0,styled_components_browser_esm.css)(notification_styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, props.theme.notifications.neutral.bg, props.theme.notifications.neutral.fg, notification_styles_Title, props.theme.notifications.neutral.fg, Message, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var styles_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-3"
})(notification_styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_Date = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Date",
    componentId: "sc-0-4"
})(notification_styles_templateObject7());
var MessageText = styled_components_browser_esm["default"].p.withConfig({
    displayName: "MessageText",
    componentId: "sc-0-5"
})(notification_styles_templateObject8());
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-6"
})(notification_styles_templateObject9(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var LinkText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LinkText",
    componentId: "sc-0-7"
})(notification_styles_templateObject10());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(notification_styles_templateObject11());
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-9"
})(notification_styles_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
;// CONCATENATED MODULE: ./src/areas/store/components/notification/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}







var notification_Notification = function(param) {
    var className = param.className, notification = param.notification, type = param.type, onClose = param.onClose;
    var renderIssue = function() {
        return notification.messages.map(function(param) {
            var id = param.id, message = param.message, time = param.time, title = param.title;
            return message && /*#__PURE__*/ react.createElement(Message, {
                key: id
            }, /*#__PURE__*/ react.createElement(styles_Header, null, title && /*#__PURE__*/ react.createElement(notification_styles_Title, null, title), time && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(styles_Date, null, time))), /*#__PURE__*/ react.createElement(MessageText, {
                dangerouslySetInnerHTML: {
                    __html: message
                }
            }));
        });
    };
    var renderInfo = function() {
        var ref, ref1, ref2, ref3;
        var item = notification;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
            to: item.link.url,
            isExternal: item.link.isExternal
        }, /*#__PURE__*/ react.createElement(Message, null, /*#__PURE__*/ react.createElement("p", null, item.message), ((ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ react.createElement(LinkText, null, ((ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.icon) && item.link.icon, /*#__PURE__*/ react.createElement(Text, _extends({}, ((ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.icon) && {
            style: {
                marginLeft: base/* layout.measurements.spacing025 */.bK.measurements.spacing025
            }
        }), item.link.text), /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, {
            size: 20,
            color: "maybeBlue700"
        })))) : /*#__PURE__*/ react.createElement(Message, null, /*#__PURE__*/ react.createElement("p", null, item.message), onClose && /*#__PURE__*/ react.createElement(CloseButton, {
            variant: "icon",
            icon: /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null),
            size: "small",
            color: "primary",
            onClick: onClose
        }));
    };
    var renderNeutral = function() {
        return notification.messages.map(function(param) {
            var id = param.id, message = param.message, time = param.time, title = param.title;
            return message && /*#__PURE__*/ react.createElement(Message, {
                key: id
            }, /*#__PURE__*/ react.createElement(styles_Header, null, title && /*#__PURE__*/ react.createElement(notification_styles_Title, null, title), time && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(styles_Date, null, time))), /*#__PURE__*/ react.createElement(MessageText, {
                dangerouslySetInnerHTML: {
                    __html: message
                }
            }));
        });
    };
    return /*#__PURE__*/ react.createElement(Notification, {
        type: type,
        className: className
    }, type === NotificationTypeEnum.INFO && renderInfo(), type === NotificationTypeEnum.ISSUE && renderIssue(), type === NotificationTypeEnum.NEUTRAL && renderNeutral());
};
/* harmony default export */ const notification = (/*#__PURE__*/(0,react.memo)(notification_Notification));

// EXTERNAL MODULE: ./src/components/notification/index.tsx + 1 modules
var components_notification = __webpack_require__(51919);
// EXTERNAL MODULE: ./src/components/products-section/index.tsx + 3 modules
var products_section = __webpack_require__(58544);
;// CONCATENATED MODULE: ./src/areas/store/styles.ts
function store_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_styles_templateObject() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  column-gap: ",
        ";\n  max-width: ",
        ";\n"
    ]);
    store_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_styles_templateObject1() {
    var data = store_styles_taggedTemplateLiteral([
        "\n    @supports (display: grid) {\n      grid-template-columns: 1fr;\n      row-gap: ",
        ";\n    }\n\n    flex-direction: column;\n  "
    ]);
    store_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_styles_templateObject2() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin: ",
        " 0;\n\n  @supports (display: grid) {\n    display: grid;\n    grid-template-columns: 30% 70%;\n  }\n\n  ",
        ";\n"
    ]);
    store_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function store_styles_templateObject3() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    store_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function store_styles_templateObject4() {
    var data = store_styles_taggedTemplateLiteral([
        "\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  "
    ]);
    store_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function store_styles_templateObject5() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: ",
        ";\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        "\n"
    ]);
    store_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function store_styles_templateObject6() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-left: ",
        ";\n  font-weight: normal;\n"
    ]);
    store_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function store_styles_templateObject7() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    store_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function store_styles_templateObject8() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    store_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function store_styles_templateObject9() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    store_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function store_styles_templateObject10() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    store_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function store_styles_templateObject11() {
    var data = store_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        ";\n"
    ]);
    store_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







var sectionContainerPadding = "0 ".concat(base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShopPage = styled_components_browser_esm["default"].div.attrs({
    "data-test": "StorePage"
}).withConfig({
    displayName: "ShopPage",
    componentId: "sc-0-0"
})(store_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.siteWidth.rem */.bK.siteWidth.rem);
var ReviewsSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ReviewsSection",
    componentId: "sc-0-1"
})(store_styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(store_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var AboutSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "AboutSection",
    componentId: "sc-0-2"
})(store_styles_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var SectionTitle = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "SectionTitle",
    componentId: "sc-0-3"
})(store_styles_templateObject5(), (0,base/* remCalc */.vR)(constants/* SECTION_TITLE_SIZE */.eZ), function(p) {
    return p.theme.lines.secondary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(store_styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var Count = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Count",
    componentId: "sc-0-4"
})(store_styles_templateObject6(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_About = (0,styled_components_browser_esm["default"])(about_store).withConfig({
    displayName: "About",
    componentId: "sc-0-5"
})(store_styles_templateObject7(), sectionContainerPadding, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AnalyticsNotification = (0,styled_components_browser_esm["default"])(notification).withConfig({
    displayName: "AnalyticsNotification",
    componentId: "sc-0-6"
})(store_styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var VerifyNotification = (0,styled_components_browser_esm["default"])(components_notification/* default */.Z).withConfig({
    displayName: "VerifyNotification",
    componentId: "sc-0-7"
})(store_styles_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StorePopularProducts = (0,styled_components_browser_esm["default"])(products_section/* ProductsSection */.Q).withConfig({
    displayName: "StorePopularProducts",
    componentId: "sc-0-8"
})(store_styles_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-9"
})(store_styles_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/shop.tsx
var shop = __webpack_require__(83198);
;// CONCATENATED MODULE: ./src/areas/store/components/notification/utils.ts
// TODO: Market-specific date formatting
var formatDate = function(date) {
    var year = date.getFullYear();
    var month = "0".concat(date.getMonth() + 1).slice(-2);
    var day = "0".concat(date.getDate()).slice(-2);
    return "".concat(year, "-").concat(month, "-").concat(day);
};


// EXTERNAL MODULE: ./src/hooks/use-reviews-data.ts
var use_reviews_data = __webpack_require__(55189);
;// CONCATENATED MODULE: ./src/hooks/use-shop-reviews-data.ts


var SortOptions;
(function(SortOptions) {
    SortOptions["MOST_HELPFUL"] = "like_score";
    SortOptions["RECENT"] = "date";
})(SortOptions || (SortOptions = {}));
var useShopReviewsData = function(param) {
    var query = param.query, id = param.id, limit = param.limit, initialData = param.initialData;
    var variables = (0,react.useMemo)(function() {
        return {
            id: id
        };
    }, [
        id
    ]);
    return (0,use_reviews_data/* useReviewsData */.t)({
        query: query,
        limit: limit,
        variables: variables,
        initialData: initialData,
        initialSort: SortOptions.RECENT
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(87838);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(27006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(39234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(48134);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(70202);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(4915);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
;// CONCATENATED MODULE: ./src/areas/store/components/reviews-section/components/sort-order-picker/index.tsx
function sort_order_picker_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || sort_order_picker_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function sort_order_picker_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_order_picker_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_order_picker_arrayLikeToArray(o, minLen);
}











var SortOrderPicker = /*#__PURE__*/ (0,react.memo)(function(props) {
    var value = props.value, onChange = props.onChange;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(false), 2), showModal = ref[0], setShowModal = ref[1];
    var sortOptions = [
        {
            title: t("reviews", "sort-option.most-recent"),
            value: SortOptions.RECENT
        },
        {
            title: t("reviews", "sort-option.most-helpful"),
            value: SortOptions.MOST_HELPFUL
        }
    ];
    var selectedOption = sortOptions.find(function(option) {
        return option.value === value;
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.ML, {
        alignment: ui/* Direction.Right */.Nm.Right,
        onFilterChange: function(option) {
            onChange(option.value);
        },
        options: sortOptions,
        defaultSelected: selectedOption
    })), /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants/* OutlinedButton */.Uc, {
        onClick: function() {
            return setShowModal(true);
        }
    }, /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(sort/* IconSort */.M, {
        size: 24
    }))), showModal && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: true,
        onRequestClose: function() {
            return setShowModal(false);
        }
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function(option) {
        /*#__PURE__*/ return react.createElement("div", {
            key: option.title
        }, /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
            onClickHandler: function() {
                onChange(option.value);
                setShowModal(false);
            },
            text: option.title,
            value: option.value,
            selectedValue: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value
        }));
    }))))));
});
/* harmony default export */ const sort_order_picker = (SortOrderPicker);

// EXTERNAL MODULE: ./src/areas/store/components/reviews-section/shop-reviews.graphql
var shop_reviews_graphql = __webpack_require__(45052);
var shop_reviews_graphql_default = /*#__PURE__*/__webpack_require__.n(shop_reviews_graphql);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/components/review-summary/components/about-link/index.tsx + 1 modules
var about_link = __webpack_require__(57616);
// EXTERNAL MODULE: ./src/components/review-summary/index.tsx + 3 modules
var review_summary = __webpack_require__(83390);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(82951);
;// CONCATENATED MODULE: ./src/areas/store/components/shop-of-the-year-promo/styles.ts
function shop_of_the_year_promo_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shop_of_the_year_promo_styles_templateObject() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n    margin: ",
        ";\n  "
    ]);
    shop_of_the_year_promo_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject1() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: ",
        ";\n  color: ",
        ";\n  border-radius: 4px;\n  padding: ",
        ";\n  margin-top: ",
        ";\n\n  ",
        "\n"
    ]);
    shop_of_the_year_promo_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject2() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  text-align: center;\n"
    ]);
    shop_of_the_year_promo_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject3() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        ""
    ]);
    shop_of_the_year_promo_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject4() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n  width: 120px;\n"
    ]);
    shop_of_the_year_promo_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject5() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    shop_of_the_year_promo_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function shop_of_the_year_promo_styles_templateObject6() {
    var data = shop_of_the_year_promo_styles_taggedTemplateLiteral([
        "\n  font-weight: normal;\n  text-transform: initial;\n  width: 100%;\n"
    ]);
    shop_of_the_year_promo_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var SotyPromo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SotyPromo",
    componentId: "sc-0-0"
})(shop_of_the_year_promo_styles_templateObject1(), function(p) {
    return p.theme.promos.bg;
}, function(p) {
    return p.theme.promos.fg;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(shop_of_the_year_promo_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var shop_of_the_year_promo_styles_Title = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(shop_of_the_year_promo_styles_templateObject2(), (0,base/* remCalc */.vR)(constants/* SUB_TITLE_SIZE */.yH));
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Description",
    componentId: "sc-0-2"
})(shop_of_the_year_promo_styles_templateObject3());
var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-3"
})(shop_of_the_year_promo_styles_templateObject4());
var UserReviewPrompt = (0,styled_components_browser_esm["default"])(components_prompt/* default */.Z).withConfig({
    displayName: "UserReviewPrompt",
    componentId: "sc-0-4"
})(shop_of_the_year_promo_styles_templateObject5());
var PromptButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "PromptButton",
    componentId: "sc-0-5"
})(shop_of_the_year_promo_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/edit/index.js
var edit = __webpack_require__(56662);
;// CONCATENATED MODULE: ./src/areas/store/components/shop-of-the-year-promo/index.tsx




var CURRENT_YEAR = new Date().getFullYear();
var shop_of_the_year_promo_SotyPromo = function(param) {
    var className = param.className, belongsTo = param.belongsTo, myReview = param.myReview, store = param.store, _year = param.year, year = _year === void 0 ? CURRENT_YEAR : _year;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var cdnDir = "".concat(market.cdn, "/g/store_of_the_year/").concat(year, "/").concat(market.code);
    var badgeURI = "".concat(cdnDir, "/award/main_award.png");
    var altText = t("campaigns", "shop-of-the-year.title-with-year", {
        year: year
    });
    return /*#__PURE__*/ react.createElement(SotyPromo, {
        className: className
    }, /*#__PURE__*/ react.createElement(Badge, null, /*#__PURE__*/ react.createElement("img", {
        src: badgeURI,
        alt: altText,
        title: altText
    })), /*#__PURE__*/ react.createElement(shop_of_the_year_promo_styles_Title, null, t("campaigns", "shop-of-the-year.shop-promo-title")), /*#__PURE__*/ react.createElement(Description, null, t("campaigns", "shop-of-the-year.shop-promo-description", {
        year: year
    })), /*#__PURE__*/ react.createElement(UserReviewPrompt, {
        belongsTo: belongsTo,
        store: store,
        currentReview: myReview,
        control: /*#__PURE__*/ react.createElement(PromptButton, {
            color: "primary",
            iconPosition: "left",
            icon: /*#__PURE__*/ react.createElement(edit/* IconEdit */.y, {
                size: 18
            })
        }, t("reviews", "button.write-review"))
    }));
};
/* harmony default export */ const shop_of_the_year_promo = (shop_of_the_year_promo_SotyPromo);

// EXTERNAL MODULE: ./src/areas/landing-page/components/soty-banner/use-soty-state.ts
var use_soty_state = __webpack_require__(79744);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
;// CONCATENATED MODULE: ./src/areas/store/components/side-column/index.tsx
function side_column_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function side_column_templateObject() {
    var data = side_column_taggedTemplateLiteral([
        "\n  margin-top: 0;\n"
    ]);
    side_column_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function side_column_templateObject1() {
    var data = side_column_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n"
    ]);
    side_column_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var SideColumn = function(param) {
    var className = param.className, store = param.store, userReviewsSummary = param.userReviewsSummary, myReview = param.myReview, selectedFilter = param.selectedFilter, onFilterChange = param.onFilterChange;
    var sotyState = (0,use_soty_state/* useSotyState */.O)();
    var belongsTo = {
        id: store.id,
        name: store.name,
        type: "store"
    };
    return /*#__PURE__*/ react.createElement(SideColumnWrapper, {
        className: className
    }, /*#__PURE__*/ react.createElement(review_summary/* ReviewsSummary */.n, {
        rating: userReviewsSummary.rating,
        count: userReviewsSummary.count,
        countTotal: userReviewsSummary.countTotal,
        distribution: userReviewsSummary.distributionNew,
        store: store,
        myReview: myReview,
        belongsTo: belongsTo,
        showPrompt: true,
        filterable: true,
        selectedFilter: selectedFilter,
        onFilterChange: onFilterChange
    }), /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "reviews"
    }, "panel.old-lead")), /*#__PURE__*/ react.createElement(about_link/* AboutReviewsLink */.H, null), sotyState === use_soty_state/* SotyState.PROMO */.P.PROMO && /*#__PURE__*/ react.createElement(SotyPromoNoMargin, {
        belongsTo: belongsTo,
        myReview: myReview,
        store: store
    }));
};
/* harmony default export */ const side_column = (SideColumn);
var SotyPromoNoMargin = (0,styled_components_browser_esm["default"])(shop_of_the_year_promo).withConfig({
    displayName: "SotyPromoNoMargin",
    componentId: "sc-0-0"
})(side_column_templateObject());
var SideColumnWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SideColumnWrapper",
    componentId: "sc-0-1"
})(side_column_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/areas/store/components/reviews-section/styles.ts
function reviews_section_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function reviews_section_styles_templateObject() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    order: 1;\n  "
    ]);
    reviews_section_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject1() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  width: 70%;\n  position: relative;\n\n  @supports (display: grid) {\n    width: auto;\n  }\n\n  ",
        ";\n"
    ]);
    reviews_section_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject2() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  justify-content: flex-end;\n  align-items: flex-start;\n  flex: 0 1 auto;\n"
    ]);
    reviews_section_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject3() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    order: 0;\n  "
    ]);
    reviews_section_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject4() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  width: 30%;\n\n  @supports (display: grid) {\n    width: auto;\n  }\n\n  ",
        ";\n"
    ]);
    reviews_section_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject5() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        ";\n  padding: ",
        ";\n"
    ]);
    reviews_section_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject6() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    reviews_section_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject7() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 0);\n  "
    ]);
    reviews_section_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function reviews_section_styles_templateObject8() {
    var data = reviews_section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n"
    ]);
    reviews_section_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var styles_sectionContainerPadding = "0 ".concat(base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Main = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Main",
    componentId: "sc-0-0"
})(reviews_section_styles_templateObject1(), styles_sectionContainerPadding, base/* media.mediumDown */.BC.mediumDown(reviews_section_styles_templateObject()));
var TabsWrapper = (0,styled_components_browser_esm["default"])(list_variants/* Row */.X2).withConfig({
    displayName: "TabsWrapper",
    componentId: "sc-0-1"
})(reviews_section_styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_SideColumn = (0,styled_components_browser_esm["default"])(side_column).withConfig({
    displayName: "SideColumn",
    componentId: "sc-0-2"
})(reviews_section_styles_templateObject4(), styles_sectionContainerPadding, base/* media.mediumDown */.BC.mediumDown(reviews_section_styles_templateObject3()));
var ReviewImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReviewImage",
    componentId: "sc-0-3"
})(reviews_section_styles_templateObject5(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var NeutralNotification = (0,styled_components_browser_esm["default"])(notification).withConfig({
    displayName: "NeutralNotification",
    componentId: "sc-0-4"
})(reviews_section_styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var LoadMoreContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LoadMoreContainer",
    componentId: "sc-0-5"
})(reviews_section_styles_templateObject8(), base/* media.mediumUp */.BC.mediumUp(reviews_section_styles_templateObject7()));

;// CONCATENATED MODULE: ./src/areas/store/components/reviews-section/index.tsx












var reviews_section_ReviewsSection = function(param) {
    var store = param.store, initialData = param.initialData, reviewsCountTotal = param.reviewsCountTotal;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var myUserId = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : ref.id;
    });
    var reviewsData = useShopReviewsData({
        query: (shop_reviews_graphql_default()),
        id: store.id,
        limit: 10,
        initialData: initialData
    });
    if (!reviewsData.data) {
        return null;
    }
    var _data = reviewsData.data, _store = _data.store, userReviews = _store.userReviews, userReviewSummary = _store.userReviewSummary;
    var ref1 = userReviews !== null && userReviews !== void 0 ? userReviews : {}, myReview = ref1.myReview, tmp = ref1.nodes, reviews = tmp === void 0 ? [] : tmp, pageInfo = ref1.pageInfo;
    var consumerInformation = store.consumerInformation && store.consumerInformation.length > 0 ? {
        messages: store.consumerInformation.map(function(info, index) {
            return {
                message: info.message,
                time: info.time && formatDate(new Date(info.time)),
                id: info.time || index,
                title: t("store", "consumer-information.title")
            };
        })
    } : null;
    var hasReviews = !!reviewsCountTotal && reviews.length > 0;
    var showMoreButton = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNext;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_SideColumn, {
        store: store,
        userReviewsSummary: userReviewSummary,
        myReview: myReview,
        selectedFilter: reviewsData.filter,
        onFilterChange: reviewsData.onFilterChange
    }), /*#__PURE__*/ react.createElement(Main, null, consumerInformation && /*#__PURE__*/ react.createElement(NeutralNotification, {
        notification: consumerInformation,
        type: NotificationTypeEnum.NEUTRAL
    }), hasReviews && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(TabsWrapper, null, /*#__PURE__*/ react.createElement(sort_order_picker, {
        value: reviewsData.sort,
        onChange: reviewsData.onSortChange
    })), /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, reviews === null || reviews === void 0 ? void 0 : reviews.map(function(userReview) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return userReview && /*#__PURE__*/ react.createElement(shop/* default */.Z, {
            belongsTo: {
                id: store.id,
                name: store.name,
                type: "store"
            },
            createdAt: userReview.createdAt,
            updatedAt: userReview.updatedAt,
            createdAtFromNow: userReview.createdAtFromNow,
            updatedAtFromNow: userReview.updatedAtFromNow,
            id: userReview.id,
            key: userReview.id,
            likes: userReview.likeScore,
            rating: userReview.convertedRating,
            reply: userReview.reply,
            replyDate: userReview.replyDate,
            text: userReview.reviewText,
            userAvatar: (ref = userReview.user) === null || ref === void 0 ? void 0 : ref.avatar,
            userDisplayName: (ref1 = userReview.user) === null || ref1 === void 0 ? void 0 : ref1.displayName,
            userId: (ref2 = userReview.user) === null || ref2 === void 0 ? void 0 : ref2.id,
            userReviewCount: (ref3 = userReview.user) === null || ref3 === void 0 ? void 0 : ref3.reviewCount,
            store: store,
            isMyReview: ((ref4 = userReview.user) === null || ref4 === void 0 ? void 0 : ref4.id) === myUserId,
            viaShop: userReview.verifiedPurchase,
            unregisteredUser: (ref5 = userReview.user) === null || ref5 === void 0 ? void 0 : ref5.unregistered,
            isFakeAccount: (ref6 = userReview.user) === null || ref6 === void 0 ? void 0 : ref6.isFakeAccount
        });
    }))), !hasReviews && (reviewsData.filter === "ALL" ? /*#__PURE__*/ react.createElement(ReviewImage, null, /*#__PURE__*/ react.createElement("img", {
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-shop-reviews-illustration-282x159px.png"),
        srcSet: "".concat(market.cdn, "/g/rfe/illustrations/no-shop-reviews-illustration-282x159px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/no-shop-reviews-illustration-564x317px.png 2x"),
        alt: t("reviews", "info.no-reviews")
    })) : /*#__PURE__*/ react.createElement(NeutralNotification, {
        notification: {
            messages: reviewsData.filter ? [
                {
                    message: t("reviews", "rating.option-".concat(reviewsData.filter.toString().toLowerCase(), "-no-result")),
                    id: reviewsData.filter
                }
            ] : []
        },
        type: NotificationTypeEnum.NEUTRAL
    })), showMoreButton && /*#__PURE__*/ react.createElement(LoadMoreContainer, null, /*#__PURE__*/ react.createElement(variants/* TextButton */.Av, {
        onClick: reviewsData.fetchMore
    }, t("common", "button.show-more")))));
};
/* harmony default export */ const reviews_section = (reviews_section_ReviewsSection);

// EXTERNAL MODULE: ./src/areas/store/query.graphql
var query_graphql = __webpack_require__(63312);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(72518);
;// CONCATENATED MODULE: ./src/areas/store/queries/use-store-page-query.ts


function useStorePageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "store",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(76493);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./src/ui/list-layouts/index.ts
var list_layouts = __webpack_require__(35883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(5521);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-outlined/index.js
var like_outlined = __webpack_require__(49816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/dislike-filled/index.js
var dislike_filled = __webpack_require__(85501);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/dislike-outlined/index.js
var dislike_outlined = __webpack_require__(74592);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(64478);
// EXTERNAL MODULE: ./src/areas/account/actions/index.js
var account_actions = __webpack_require__(20673);
;// CONCATENATED MODULE: ./src/areas/store/components/like-dislike/index.tsx
function like_dislike_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function like_dislike_templateObject() {
    var data = like_dislike_taggedTemplateLiteral([
        "\n  flex: none;\n"
    ]);
    like_dislike_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var LikeDislikeButtons = function(param) {
    var shopId = param.shopId;
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.shopPreference;
    }), fetchingLikes = ref2.fetchingLikes, fetchingDislikes = ref2.fetchingDislikes;
    var likedShop = ((me === null || me === void 0 ? void 0 : (ref = me.likes) === null || ref === void 0 ? void 0 : ref.shops) || []).includes("".concat(shopId));
    var dislikedShop = ((me === null || me === void 0 ? void 0 : (ref1 = me.dislikes) === null || ref1 === void 0 ? void 0 : ref1.shops) || []).includes("".concat(shopId));
    var loadingShopPreference = fetchingLikes || fetchingDislikes;
    return /*#__PURE__*/ react.createElement(list_variants/* Row */.X2, {
        gap: 0.5
    }, /*#__PURE__*/ react.createElement(Tooltip, {
        title: t("account", "shop-preference.tab-ingress"),
        placement: ui/* Direction.Up */.Nm.Up,
        align: ui/* Direction.Left */.Nm.Left
    }, /*#__PURE__*/ react.createElement(variants/* OutlinedButton */.Uc, {
        loading: loadingShopPreference,
        size: variants/* ButtonSize.SMALL */.qE.SMALL,
        onClick: function() {
            return dispatch((0,account_actions/* likeShop */.m)("".concat(shopId)));
        }
    }, /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, likedShop ? /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, null) : /*#__PURE__*/ react.createElement(like_outlined/* IconLikeOutlined */.q, null)))), /*#__PURE__*/ react.createElement(Tooltip, {
        title: t("account", "shop-preference.tab-ingress"),
        placement: ui/* Direction.Up */.Nm.Up,
        align: ui/* Direction.Left */.Nm.Left
    }, /*#__PURE__*/ react.createElement(variants/* OutlinedButton */.Uc, {
        loading: loadingShopPreference,
        size: variants/* ButtonSize.SMALL */.qE.SMALL,
        onClick: function() {
            return dispatch((0,account_actions/* dislikeShop */.XW)("".concat(shopId)));
        }
    }, /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, dislikedShop ? /*#__PURE__*/ react.createElement(dislike_filled/* IconDislikeFilled */.h, null) : /*#__PURE__*/ react.createElement(dislike_outlined/* IconDislikeOutlined */.R, null)))));
};
var Tooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "Tooltip",
    componentId: "sc-0-0"
})(like_dislike_templateObject());

;// CONCATENATED MODULE: ./src/areas/store/store.tsx
function store_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function store_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return store_arrayLikeToArray(arr);
}
function store_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function store_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function store_toConsumableArray(arr) {
    return store_arrayWithoutHoles(arr) || store_iterableToArray(arr) || store_unsupportedIterableToArray(arr) || store_nonIterableSpread();
}
function store_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return store_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen);
}

























var StorePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useStorePageQuery(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        "data-test": "StorePage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(StorePage, {
        data: data
    }) : null);
};
var StorePage = function(param) {
    var data = param.data;
    var ref, ref1;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var push = (0,react_router_dom/* useHistory */.k6)().push;
    var analyticsAccess = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : (ref1 = ref.analyticsAccess) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.stores) === null || ref2 === void 0 ? void 0 : ref2.find(function(store) {
            return store.id === data.store.id;
        });
    });
    var review = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.review;
    });
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var store = data.store;
    var sotyBadge = ((ref = store.storeOfTheYearAwards) === null || ref === void 0 ? void 0 : ref.length) ? store.storeOfTheYearAwards[0] : null;
    var _ref = dist_default().parse(location.search), notification = _ref.notification, queryParams = _objectWithoutProperties(_ref, [
        "notification"
    ]);
    var userReviewsSummary = review.userReviews && review.userReviews.summary ? review.userReviews.summary : store.userReviewSummary;
    var getReviewsCount = function() {
        var countTotal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : userReviewsSummary === null || userReviewsSummary === void 0 ? void 0 : userReviewsSummary.countTotal;
        return countTotal ? "(".concat(countTotal > 500 ? "500+" : countTotal, ")") : null;
    };
    var reviewsCountTotal = getReviewsCount();
    (0,react.useEffect)(function() {
        if (notification === "verify-success") {
            var ref, ref1;
            (0,tracking/* storeReviewPublished */.XZ)({
                type: tracking/* ShopReviewType.SHOP */.zv.SHOP,
                storeId: data === null || data === void 0 ? void 0 : (ref = data.store) === null || ref === void 0 ? void 0 : ref.id,
                storeName: data === null || data === void 0 ? void 0 : (ref1 = data.store) === null || ref1 === void 0 ? void 0 : ref1.name
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleStoreLinkClick = function(scope) {
        return function() {
            dispatch((0,actions/* storeLinkClick */.P)());
            (0,conversion/* trackShopClickWithRevenue */.Yn)({
                shopId: store.id,
                scope: scope
            });
        };
    };
    var handleCloseNotification = (0,react.useCallback)(function() {
        push("".concat(location.pathname, "?").concat(dist_default().stringify(queryParams)));
    }, [
        location.pathname,
        push,
        queryParams
    ]);
    var verifyNotificationMessage;
    var verifyNotificationType = types/* NotificationTypes.INFO */.j.INFO;
    switch(notification){
        case "verify-success":
            verifyNotificationMessage = t("reviews", "notification.verify-success");
            break;
        case "verify-fail":
            verifyNotificationMessage = t("reviews", "dialog.unknown-error");
            verifyNotificationType = types/* NotificationTypes.ISSUE */.j.ISSUE;
            break;
        case "delete-success":
            verifyNotificationMessage = t("reviews", "dialog.delete-success");
            break;
        default:
    }
    // Sort products on how cheap the store is compared to other stores,
    var sortedProducts = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return store_toConsumableArray((ref1 = (ref = store.products) === null || ref === void 0 ? void 0 : ref.nodes) !== null && ref1 !== void 0 ? ref1 : []).sort(function(a, b) {
            var ref, ref1, ref2, ref3;
            var ref4;
            var ai = (ref4 = a === null || a === void 0 ? void 0 : (ref = a.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(p) {
                var ref;
                return (p === null || p === void 0 ? void 0 : (ref = p.store) === null || ref === void 0 ? void 0 : ref.id) === store.id;
            })) !== null && ref4 !== void 0 ? ref4 : 0;
            var ref5;
            var bi = (ref5 = b === null || b === void 0 ? void 0 : (ref2 = b.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.nodes) === null || ref3 === void 0 ? void 0 : ref3.findIndex(function(p) {
                var ref;
                return (p === null || p === void 0 ? void 0 : (ref = p.store) === null || ref === void 0 ? void 0 : ref.id) === store.id;
            })) !== null && ref5 !== void 0 ? ref5 : 0;
            return ai - bi;
        });
    }, [
        (ref1 = store.products) === null || ref1 === void 0 ? void 0 : ref1.nodes,
        store.id
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        containerProps: {
            onClick: function(nextPage) {
                (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking_tracking/* InternalNavigationScope.BREADCRUMB */.U.BREADCRUMB,
                    nextPage: nextPage
                });
            }
        }
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), /*#__PURE__*/ react.createElement("span", null, store.name))), verifyNotificationMessage ? /*#__PURE__*/ react.createElement(VerifyNotification, {
        type: verifyNotificationType,
        message: verifyNotificationMessage,
        onClose: handleCloseNotification
    }) : null, (analyticsAccess === null || analyticsAccess === void 0 ? void 0 : analyticsAccess.url) ? /*#__PURE__*/ react.createElement(AnalyticsNotification, {
        notification: {
            message: t("store", "store.pj-analytics-settings"),
            link: {
                text: t("store", "store.pj-analytics-link"),
                url: "analyticsAccess.url",
                icon: /*#__PURE__*/ react.createElement(analytics/* IconAnalytics */.n, {
                    size: 16,
                    color: "maybeBlue700"
                }),
                isExternal: true
            }
        },
        type: NotificationTypeEnum.INFO
    }) : null, /*#__PURE__*/ react.createElement(ShopPage, null, /*#__PURE__*/ react.createElement(header, {
        sotyBadge: sotyBadge,
        store: store,
        storeLinkClick: handleStoreLinkClick(conversion/* TrackClickScope.SHOP_PAGE_HEADER */.b8.SHOP_PAGE_HEADER)
    }), isAuthenticated && /*#__PURE__*/ react.createElement(list_layouts/* ColumnWithGutter */.U, null, /*#__PURE__*/ react.createElement(LikeDislikeButtons, {
        shopId: store.id
    })), !!sortedProducts.length && /*#__PURE__*/ react.createElement(StorePopularProducts, {
        dataTestType: "store-popular-products",
        products: sortedProducts,
        title: t("brand", "popular-products.title", {
            brand: store.name
        })
    }), /*#__PURE__*/ react.createElement(sticky_tab_nav/* StickyTabNavigation */.g, {
        defaultActiveTabId: TabAnchor.REVIEWS,
        tabs: [
            {
                id: TabAnchor.REVIEWS,
                title: reviewsCountTotal ? t("store", "store-menu.reviews", {
                    count: reviewsCountTotal
                }) : t("store", "header.reviews")
            },
            {
                id: TabAnchor.ABOUT,
                title: t("store", "store-menu.about")
            }
        ]
    }), /*#__PURE__*/ react.createElement(ReviewsSection, {
        id: TabAnchor.REVIEWS
    }, /*#__PURE__*/ react.createElement(reviews_section, {
        store: store,
        initialData: {
            store: {
                userReviews: store.userReviews,
                userReviewSummary: store.userReviewSummary
            }
        },
        reviewsCountTotal: reviewsCountTotal
    })), /*#__PURE__*/ react.createElement(AboutSection, {
        id: TabAnchor.ABOUT
    }, /*#__PURE__*/ react.createElement(SectionTitle, null, t("store", "store-menu.about")), /*#__PURE__*/ react.createElement(styles_About, {
        store: store,
        storeLinkClick: handleStoreLinkClick(conversion/* TrackClickScope.SHOP_PAGE_ABOUT */.b8.SHOP_PAGE_ABOUT)
    }))));
};
/* harmony default export */ const store = (StorePageLoader);


/***/ }),

/***/ 37571:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ InfoList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/info-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:last-child)::after {\n    content: '•';\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.theme.text.secondary);
});
var Content = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(_templateObject1());
var Item = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Item",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/info-list/index.tsx
/* eslint-disable react/no-array-index-key */ 

var isStringArray = function(test) {
    return Array.isArray(test) && test.every(function(value) {
        return typeof value === "string";
    });
};
var InfoList = function(param) {
    var className = param.className, list = param.list;
    if (!(list === null || list === void 0 ? void 0 : list.length)) return null;
    return /*#__PURE__*/ react.createElement(List, {
        className: className
    }, list && isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, /*#__PURE__*/ react.createElement(Content, null, item));
    }), list && !isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, item);
    }));
};


/***/ }),

/***/ 10849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ like_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(25629);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
;// CONCATENATED MODULE: ./src/components/like-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  color: ",
        ";\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n\n    path {\n      fill: ",
        ";\n    }\n  }\n\n  gap: ",
        ";\n  transition: gap 150ms ease;\n\n  ",
        " {\n    overflow: hidden;\n    transition: max-width 150ms ease;\n    max-width: ",
        ";\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var LikeText = (0,styled_components_browser_esm["default"])(variants/* BodySmallText */.oI).withConfig({
    displayName: "LikeText",
    componentId: "sc-0-0"
})(_templateObject());
var StyledLikeButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StyledLikeButton",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.liked ? 0 : base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
}, LikeText, function(p) {
    return p.liked ? 0 : "999px";
});
var LikesWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LikesWrapper",
    componentId: "sc-0-2"
})(_templateObject2());
var LikeIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LikeIconWrapper",
    componentId: "sc-0-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(5521);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-outlined/index.js
var like_outlined = __webpack_require__(49816);
;// CONCATENATED MODULE: ./src/components/like-button/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var LikeButton = function(param) {
    var className = param.className, onClick = param.onClick, liked = param.liked, likes = param.likes, _size = param.size, size = _size === void 0 ? 20 : _size, text = param.text;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(likes), 2), likeScore = ref[0], setLikeScore = ref[1];
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref1[0], setShowLoginPromo = ref1[1];
    var handler = (0,react.useCallback)(function() {
        if (!isAuthenticated) {
            setShowLoginPromo(true);
            return;
        }
        onClick();
        // Fake a +1 in like score as the real data is not updated in real time
        if (!liked) {
            setLikeScore((likes || 0) + 1);
        }
    }, [
        onClick,
        likes,
        liked,
        isAuthenticated
    ]);
    var hideLoginPromo = (0,react.useCallback)(function() {
        setShowLoginPromo(false);
    }, []);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showLoginPromo ? /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: true,
        onRequestClose: hideLoginPromo
    }) : null, /*#__PURE__*/ react.createElement(StyledLikeButton, {
        onClick: handler,
        liked: liked,
        className: className
    }, /*#__PURE__*/ react.createElement(LikeText, null, text || t("reviews", "button.helpful")), /*#__PURE__*/ react.createElement(LikeIconWrapper, null, liked ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likeScore || 1)) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_outlined/* IconLikeOutlined */.q, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likes || null)))));
};
/* harmony default export */ const like_button = (LikeButton);


/***/ }),

/***/ 51919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ notification)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/notification/types.ts
var types = __webpack_require__(65348);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/components/notification/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 5px;\n    position: relative;\n    padding: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n\n    ",
        " {\n      padding-right: ",
        ";\n\n      &:not(:last-of-type) {\n        margin-bottom: ",
        ";\n      }\n\n      > svg {\n        margin: 0 ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  &::after {\n    content: '|';\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject());
var Message = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-1"
})(_templateObject1());
var Notification = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Notification",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, props.theme.notifications[props.type].bg, props.theme.notifications[props.type].fg, Message, props.hasCloseButton ? base/* layout.measurements.spacing300 */.bK.measurements.spacing300 : "0", base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_Date = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Date",
    componentId: "sc-0-4"
})(_templateObject4());
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var LinkText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LinkText",
    componentId: "sc-0-6"
})(_templateObject6());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-7"
})(_templateObject7());
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-8"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
;// CONCATENATED MODULE: ./src/components/notification/index.tsx





var notification_Notification = function(param) {
    var className = param.className, type = param.type, title = param.title, message = param.message, time = param.time, onClose = param.onClose, link = param.link;
    var notification = /*#__PURE__*/ react.createElement(Notification, {
        type: type,
        className: className,
        hasCloseButton: Boolean(onClose)
    }, /*#__PURE__*/ react.createElement(Message, null, (title || time) && /*#__PURE__*/ react.createElement(Header, null, title && /*#__PURE__*/ react.createElement(Title, null, title), time && /*#__PURE__*/ react.createElement(react.Fragment, null, title && /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(styles_Date, null, time))), /*#__PURE__*/ react.createElement("p", null, message)), onClose && /*#__PURE__*/ react.createElement(CloseButton, {
        variant: "icon",
        icon: /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null),
        size: "small",
        color: type === types/* NotificationTypes.ISSUE */.j.ISSUE ? "negative" : "primary",
        onClick: onClose
    }));
    return (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: link.url,
        isExternal: link.isExternal
    }, notification) : notification;
};
/* harmony default export */ const notification = (/*#__PURE__*/(0,react.memo)(notification_Notification));


/***/ }),

/***/ 65348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ NotificationTypes)
/* harmony export */ });
var NotificationTypes;
(function(NotificationTypes) {
    NotificationTypes["INFO"] = "info";
    NotificationTypes["ISSUE"] = "issue";
    NotificationTypes["NEUTRAL"] = "neutral";
})(NotificationTypes || (NotificationTypes = {}));


/***/ }),

/***/ 57616:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* binding */ AboutReviewsLink)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/info-page-link/index.js
var info_page_link = __webpack_require__(92674);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/review-summary/components/about-link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: 1.4;\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var About = styled_components_browser_esm["default"].div.withConfig({
    displayName: "About",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(24050);
;// CONCATENATED MODULE: ./src/components/review-summary/components/about-link/index.tsx





var AboutReviewsLink = function(props) {
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), market = ref1.market, t = ref1.t;
    return /*#__PURE__*/ react.createElement(About, {
        className: props.className
    }, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 16
    }), /*#__PURE__*/ react.createElement(info_page_link/* default */.Z, {
        id: (ref = market.infoPageMap) === null || ref === void 0 ? void 0 : ref.aboutReviews
    }, t("reviews", "reviews.about-reviews")));
};


/***/ }),

/***/ 56687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ NoReviews)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10297);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66431);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33399);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5492);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-align: center;\n\n  p {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  max-width: 310px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var NoReviews = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), market = ref.market, t = ref.t;
    var getNoReviewsText = function() {
        if (props.reviewSource) {
            return t("reviews", props.reviewSource === "users" ? "info.multi-source-reviews-no-reviews" : "info.multi-source-reviews-no-external-reviews");
        }
        return t("reviews", "info.no-reviews");
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FirstToReviewText, null, props.showImage && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
        alt: "",
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-product-reviews-illustration-400x218px.png"),
        srcSet: "".concat(market.cdn, "/g/rfe/illustrations/no-product-reviews-illustration-400x218px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/no-product-reviews-illustration-800x437px.png 2x")
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__/* .H3Text */ .I7, null, getNoReviewsText()), props.name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__/* .BodySmallText */ .oI, {
        containerProps: {
            dangerouslySetInnerHTML: {
                __html: "".concat(t("reviews", "info.first-review.md", {
                    name: props.name
                }))
            }
        }
    }));
};
var FirstToReviewText = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "FirstToReviewText",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumDown */ .BC.mediumDown(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 83390:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": () => (/* binding */ ReviewsSummary)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(31913);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(27424);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(32401);
// EXTERNAL MODULE: ./src/components/review-summary/components/no-reviews/index.tsx
var no_reviews = __webpack_require__(56687);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var utils = __webpack_require__(55776);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/review-summary/components/rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row-reverse;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    gap: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      align-self: flex-start;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: normal;\n    color: ",
        ";\n\n    ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &::after {\n    margin: 0 ",
        ";\n    content: '•';\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    gap: 0;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    gap: ",
        ";\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    gap: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  align-items: center;\n\n  ",
        " {\n    font-size: 32px;\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  column-gap: ",
        ";\n\n  ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n  }\n\n  ",
        " {\n    grid-area: 1 / 2 / 2 / 3;\n  }\n\n  ",
        " {\n    grid-area: 2 / 2 / 3 / 3;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var EMOTICON_SIZE = 48;
var ScoreAndRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScoreAndRating",
    componentId: "sc-0-0"
})(_templateObject2(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* media.largeUp */.BC.largeUp(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Score = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Score",
    componentId: "sc-0-1"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), p.theme.text.primary, !p.store && (0,styled_components_browser_esm.css)(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), p.store && (0,styled_components_browser_esm.css)(_templateObject4()));
});
var Divider = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-2"
})(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Rating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Rating",
    componentId: "sc-0-3"
})(_templateObject7());
var Count = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Count",
    componentId: "sc-0-4"
})(_templateObject8());
var ProductRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductRating",
    componentId: "sc-0-5"
})(_templateObject12(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, Score, base/* media.smallOnly */.BC.smallOnly(_templateObject9()), base/* media.mediumOnly */.BC.mediumOnly(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025), base/* media.largeUp */.BC.largeUp(_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var ShopRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopRating",
    componentId: "sc-0-6"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Rating, Score, Count);

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
;// CONCATENATED MODULE: ./src/components/review-summary/components/rating/index.tsx









var SummaryRating = function(param) {
    var type = param.type, rating = param.rating, count = param.count, countTotal = param.countTotal, name = param.name, _showNoReviewsPrompt = param.showNoReviewsPrompt, showNoReviewsPrompt = _showNoReviewsPrompt === void 0 ? false : _showNoReviewsPrompt;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var rate = rating !== undefined && rating !== null ? rating_helper/* default.convert */.Z.convert(rating) : null;
    var ratingCount = count && count > 500 ? "500+" : count;
    if (showNoReviewsPrompt && type === "store" && !count) {
        return /*#__PURE__*/ react.createElement(no_reviews/* NoReviews */.a, {
            name: name
        });
    }
    if (showNoReviewsPrompt && type === "product" && !((count || countTotal) && rate && rate.rounded)) {
        return /*#__PURE__*/ react.createElement(no_reviews/* NoReviews */.a, {
            name: name,
            showImage: true
        });
    }
    if (type === "store") {
        var smileyRating = count && rate !== null && (rate === null || rate === void 0 ? void 0 : rate.real) !== undefined ? (0,utils/* getSmileyRating */.P)(rate.rounded) : null;
        var label = (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text) ? t("reviews", smileyRating.text) : "";
        return /*#__PURE__*/ react.createElement(ShopRating, null, smileyRating && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.iconType) ? /*#__PURE__*/ react.createElement(Rating, null, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
            type: smileyRating.iconType,
            size: EMOTICON_SIZE,
            disabled: !count,
            ariaLabel: label
        })) : null, !!rate && !!smileyRating && !!ratingCount && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Score, {
            store: type === "store"
        }, rate.roundedString, (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text) && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Divider, null), t("reviews", smileyRating.text))), /*#__PURE__*/ react.createElement(Count, null, t("reviews", "rating.n-reviews", {
            n: ratingCount,
            count: ratingCount
        }))));
    }
    return /*#__PURE__*/ react.createElement(ProductRating, null, /*#__PURE__*/ react.createElement(ScoreAndRating, null, /*#__PURE__*/ react.createElement(Score, null, rate === null || rate === void 0 ? void 0 : rate.rounded), /*#__PURE__*/ react.createElement(Rating, null, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        size: "xl",
        rate: count ? rating : 0,
        count: count,
        showCounter: false,
        secondaryColors: !count,
        singleStar: true
    })), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        size: "large",
        rate: count ? rating : 0,
        count: count,
        showCounter: false,
        secondaryColors: !count
    })))), /*#__PURE__*/ react.createElement(Count, null, t("reviews", "rating.n-reviews", {
        n: ratingCount !== null && ratingCount !== void 0 ? ratingCount : 0,
        count: ratingCount !== null && ratingCount !== void 0 ? ratingCount : 0
    })));
};
/* harmony default export */ const review_summary_components_rating = (SummaryRating);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/edit/index.js
var edit = __webpack_require__(56662);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(66512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(82951);
;// CONCATENATED MODULE: ./src/components/review-summary/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      max-width: 270px;\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  > ",
        " {\n    max-width: unset;\n\n    ",
        "\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 0;\n  margin: 0 auto;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n          gap: 0;\n          flex-direction: row;\n\n          ",
        " {\n            min-width: 0;\n            flex-basis: 47%;\n            justify-content: center;\n          }\n\n          ",
        " {\n            flex-grow: 1;\n          }\n        "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: ",
        ";\n\n    ",
        "\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n  position: relative;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: 100%;\n  background: ",
        ";\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n  color: ",
        ";\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n        text-decoration: underline;\n      "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    display: contents;\n  }\n\n  > * {\n    opacity: ",
        ";\n  }\n\n  &:hover > * {\n    opacity: 1;\n  }\n\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n  line-height: 1;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  text-align: center;\n  flex-direction: row;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  align-items: center;\n\n  /* Increase clickable area of DistributionRows */\n  ",
        " {\n    &:after {\n      content: '';\n      position: absolute;\n      top: -",
        ";\n      bottom: -",
        ";\n      left: -",
        ";\n      right: -",
        ";\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = styles_taggedTemplateLiteral([
        "\n    order: -1;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}





var meterHeight = "6px";
var StyledUserReviewPrompt = (0,styled_components_browser_esm["default"])(components_prompt/* default */.Z).withConfig({
    displayName: "StyledUserReviewPrompt",
    componentId: "sc-0-0"
})(styles_templateObject());
var WriteReviewButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "WriteReviewButtonContainer",
    componentId: "sc-0-1"
})(styles_templateObject2(), StyledUserReviewPrompt, base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject1()));
var RatingDistributionContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingDistributionContainer",
    componentId: "sc-0-2"
})(styles_templateObject3());
var RatingContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingContainer",
    componentId: "sc-0-3"
})(styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Summary = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Summary",
    componentId: "sc-0-4"
})(styles_templateObject5(), function(p) {
    return p.theme.text.quaternary;
});
var SummaryWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryWrapper",
    componentId: "sc-0-5"
})(styles_templateObject9(), function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject8(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, props.mediumDownColumnView && (0,styled_components_browser_esm.css)(styles_templateObject7(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject6(), RatingContainer, RatingDistributionContainer)));
});
var Meter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Meter",
    componentId: "sc-0-6"
})(styles_templateObject10(), meterHeight, function(p) {
    return p.theme.lines.primary;
}, meterHeight);
var Indicator = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Indicator",
    componentId: "sc-0-7"
})(styles_templateObject11(), function(p) {
    return p.width;
}, function(p) {
    return p.theme.colors.maybeBlue900;
}, meterHeight, meterHeight);
var MeterLabel = styled_components_browser_esm["default"].span.withConfig({
    displayName: "MeterLabel",
    componentId: "sc-0-8"
})(styles_templateObject12(), function(p) {
    return p.theme.text.primary;
});
var MeterCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "MeterCount",
    componentId: "sc-0-9"
})(styles_templateObject13(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var DistributionRow = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DistributionRow",
    componentId: "sc-0-10"
})(_templateObject16(), function(p) {
    return p.dimmed ? 0.33 : 1;
}, Meter, function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject14(), p.theme.colors.maybeBlue900);
}, MeterLabel, function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject15());
});
var Title = (0,styled_components_browser_esm["default"])(variants/* H3Text */.I7).withConfig({
    displayName: "Title",
    componentId: "sc-0-11"
})(_templateObject17(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StarRate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StarRate",
    componentId: "sc-0-12"
})(_templateObject18(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var IconText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconText",
    componentId: "sc-0-13"
})(_templateObject19(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var Distribution = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Distribution",
    componentId: "sc-0-14"
})(_templateObject20(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, Meter, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var WriteReviewEncouragement = (0,styled_components_browser_esm["default"])(variants/* BodySmallText */.oI).withConfig({
    displayName: "WriteReviewEncouragement",
    componentId: "sc-0-15"
})(_templateObject22(), base/* media.mediumDown */.BC.mediumDown(_templateObject21()));

// EXTERNAL MODULE: ./src/components/rating/smiley-rating/types.ts
var types = __webpack_require__(49915);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(71406);
;// CONCATENATED MODULE: ./src/components/review-summary/index.tsx











var ratingFilterMap = [
    "EXCELLENT",
    "GOOD",
    "OK",
    "BAD",
    "TERRIBLE"
];
var ReviewsSummary = /*#__PURE__*/ (0,react.memo)(function(props) {
    var className = props.className, rating = props.rating, count = props.count, countTotal = props.countTotal, distribution = props.distribution, belongsTo = props.belongsTo, _showPrompt = props.showPrompt, showPrompt = _showPrompt === void 0 ? true : _showPrompt, store = props.store, myReview = props.myReview, _mediumDownColumnView = props.mediumDownColumnView, mediumDownColumnView = _mediumDownColumnView === void 0 ? false : _mediumDownColumnView, _filterable = props.filterable, filterable = _filterable === void 0 ? false : _filterable, _selectedFilter = props.selectedFilter, selectedFilter = _selectedFilter === void 0 ? "ALL" : _selectedFilter, _onFilterChange = props.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onFilterChange, onFilterChange = _onFilterChange === void 0 ? function() {} : _onFilterChange;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var filterHandler = (0,react.useCallback)(function(filter) {
        return function() {
            if (filter === "ALL" || filter === selectedFilter) {
                return onFilterChange("ALL");
            }
            return onFilterChange(filter);
        };
    }, [
        onFilterChange,
        selectedFilter
    ]);
    var renderEmoticon = function(rate) {
        var ref;
        var smiley = (ref = (0,utils/* getSmileyRating */.P)(rate)) === null || ref === void 0 ? void 0 : ref.text;
        var label = smiley ? t("reviews", smiley) : rate.toString();
        switch(rate){
            case 1:
                return /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
                    type: types/* SmileyType.ANGRY */.P.ANGRY,
                    disabled: false,
                    size: 24,
                    ariaLabel: label
                });
            case 2:
                return /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
                    type: types/* SmileyType.DISSATISFIED */.P.DISSATISFIED,
                    disabled: false,
                    size: 24,
                    ariaLabel: label
                });
            case 3:
                return /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
                    type: types/* SmileyType.NEUTRAL */.P.NEUTRAL,
                    disabled: false,
                    size: 24,
                    ariaLabel: label
                });
            case 4:
                return /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
                    type: types/* SmileyType.SMILING */.P.SMILING,
                    disabled: false,
                    size: 24,
                    ariaLabel: label
                });
            case 5:
                return /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
                    type: types/* SmileyType.LAUGHING */.P.LAUGHING,
                    disabled: false,
                    size: 24,
                    ariaLabel: label
                });
            default:
                return null;
        }
    };
    var WriteReviewButton = belongsTo && showPrompt && /*#__PURE__*/ react.createElement(StyledUserReviewPrompt, {
        belongsTo: belongsTo,
        store: store,
        currentReview: myReview,
        control: /*#__PURE__*/ react.createElement("div", {
            "data-test": "WriteReviewButton"
        }, /*#__PURE__*/ react.createElement(button_variants/* PrimaryButton */.KM, {
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(IconText, null, /*#__PURE__*/ react.createElement(ui_button/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(edit/* IconEdit */.y, {
            size: 22
        })), /*#__PURE__*/ react.createElement(ui_button/* ButtonText */.oD, null, t("reviews", "button.write-review")))))
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SummaryWrapper, {
        className: className,
        "data-test": "ReviewsSummary",
        mediumDownColumnView: mediumDownColumnView
    }, /*#__PURE__*/ react.createElement(RatingContainer, null, /*#__PURE__*/ react.createElement(Summary, null, /*#__PURE__*/ react.createElement(review_summary_components_rating, {
        type: belongsTo === null || belongsTo === void 0 ? void 0 : belongsTo.type,
        rating: rating,
        count: count,
        countTotal: countTotal,
        name: belongsTo === null || belongsTo === void 0 ? void 0 : belongsTo.name,
        showNoReviewsPrompt: (belongsTo === null || belongsTo === void 0 ? void 0 : belongsTo.type) === "store"
    }))), /*#__PURE__*/ react.createElement(RatingDistributionContainer, null, /*#__PURE__*/ react.createElement(Distribution, null, distribution === null || distribution === void 0 ? void 0 : distribution.slice().reverse().map(function(dist, mapIndex) {
        /*#__PURE__*/ return react.createElement(DistributionRow, {
            key: dist.score,
            disabled: !filterable,
            activationEffect: false,
            onClick: filterHandler(ratingFilterMap[mapIndex]),
            dimmed: selectedFilter !== ratingFilterMap[mapIndex] && selectedFilter !== "ALL",
            selected: selectedFilter === ratingFilterMap[mapIndex]
        }, /*#__PURE__*/ react.createElement(MeterLabel, null, (belongsTo === null || belongsTo === void 0 ? void 0 : belongsTo.type) === "store" ? renderEmoticon(dist.score) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StarRate, null, dist.score), " ", /*#__PURE__*/ react.createElement(icons/* StarIcon */.r7, {
            height: 12,
            styling: "active"
        }))), /*#__PURE__*/ react.createElement(Meter, null, /*#__PURE__*/ react.createElement(Indicator, {
            width: "".concat(dist.percentage, "%")
        })), /*#__PURE__*/ react.createElement(MeterCount, null, "(", dist.count, ")"));
    })))), /*#__PURE__*/ react.createElement(WriteReviewButtonContainer, null, WriteReviewButton), (belongsTo === null || belongsTo === void 0 ? void 0 : belongsTo.type) === "product" && /*#__PURE__*/ react.createElement(WriteReviewEncouragement, null, t("reviews", "product-page.write-review-encouragement")));
});



/***/ }),

/***/ 46885:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ShopLinkCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(49213);
// EXTERNAL MODULE: ./src/components/product-card-new/components/price.tsx
var components_price = __webpack_require__(34592);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(90243);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
;// CONCATENATED MODULE: ./src/components/shop-link-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: inherit;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  padding: ",
        ";\n  min-height: 47px;\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  min-width: 90px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  margin-left: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(59, 163, 212, 1);\n  box-shadow: 0px 2px 4px rgba(5, 37, 46, 0.24);\n  border-radius: ",
        ";\n  margin-left: ",
        ";\n  margin-top: -",
        ";\n  margin-bottom: -",
        ";\n  width: 36px;\n  height: 36px;\n\n  :hover {\n    cursor: pointer;\n  }\n\n  svg {\n    fill: rgba(255, 255, 255, 1);\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var BUTTON_MARGIN_UNFEATURED = 52;
var BUTTON_MARGIN_UNFEATURED_MOBILE = 44;
var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* styledUtils.overlay */.au.overlay());
var StoreLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StoreLink",
    componentId: "sc-0-0"
})(_templateObject1(), sharedStyles);
var UnfeaturedStore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnfeaturedStore",
    componentId: "sc-0-1"
})(_templateObject2(), sharedStyles);
var Logo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Count = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Count",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.quaternary;
});
var PriceInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInformation",
    componentId: "sc-0-4"
})(_templateObject5());
var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceWrapper",
    componentId: "sc-0-5"
})(_templateObject7(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED, "px") : "0";
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED_MOBILE, "px") : "-".concat(base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
}));
var OfferButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "OfferButton",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-7"
})(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
;// CONCATENATED MODULE: ./src/components/shop-link-card/components/price-information/index.tsx





var price_information_PriceInformation = function(props) {
    var price = props.price, stockStatus = props.stockStatus, isDeal = props.isDeal, featured = props.featured;
    return /*#__PURE__*/ react.createElement(PriceInformation, null, /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: stockStatus || undefined
    }), /*#__PURE__*/ react.createElement(PriceWrapper, {
        $featured: featured
    }, /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        isDeal: isDeal
    })), featured && /*#__PURE__*/ react.createElement(OfferButton, null, /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, {
        color: "base0"
    })));
};

// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(9450);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/utils.ts
var utils = __webpack_require__(20833);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(77660);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(32401);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(27424);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var smiley_rating_utils = __webpack_require__(55776);
;// CONCATENATED MODULE: ./src/components/shop-link-card/index.tsx












var ShopLinkCard = function(props) {
    var id = props.id, dataTest = props["data-test"], name = props.name, hasLogo = props.hasLogo, logoUrl = props.logoUrl, logoWidth = props.logoWidth, featured = props.featured, pathname = props.pathname, rating = props.rating, _numericRating = props.numericRating, numericRating = _numericRating === void 0 ? false : _numericRating, reviewCount = props.reviewCount, renderMode = props.renderMode, stockStatus = props.stockStatus, price = props.price, productId = props.productId, priceId = props.priceId, _isDeal = props.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _clickTrackingScope = props.// Use this as default since this component originally was refactored out
    // from src/components/user-review-card
    clickTrackingScope, clickTrackingScope = _clickTrackingScope === void 0 ? conversion/* TrackClickScope.USER_REVIEW_CARD */.b8.USER_REVIEW_CARD : _clickTrackingScope;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var count = reviewCount && reviewCount > 500 ? "500+" : reviewCount;
    var highResolutionLogo = logoUrl ? {
        url: logoUrl,
        width: logoWidth
    } : null;
    var featuredStore = Boolean(featured);
    var rate = rating_helper/* default.convert */.Z.convert(rating || 0);
    var smileyRating = (0,smiley_rating_utils/* getSmileyRating */.P)(rate.real);
    var ratingType = numericRating ? rate.rounded : t("reviews", smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text);
    var trackClickOut = function() {
        if (!priceId || !productId) {
            return;
        }
        // Track revenue and event on click out
        (0,utils/* logRevenueEvent */.mb)(String(priceId), productId);
        dispatch((0,product/* productPriceClick */.Po)(productId, price, featuredStore, "", false, "StoreCard"));
        (0,conversion/* trackOfferClickWithRevenue */.Rx)({
            scope: clickTrackingScope,
            offerId: priceId,
            productId: productId
        });
    };
    var renderContent = function() {
        /*#__PURE__*/ return react.createElement(react.Fragment, null, id && name && /*#__PURE__*/ react.createElement(Logo, {
            storeId: id,
            name: name,
            hasImage: Boolean(hasLogo),
            featured: featuredStore,
            logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
            width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width,
            showHighResolutionLogo: Boolean(highResolutionLogo)
        }), rating && rating !== 0 && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.iconType) && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
            type: smileyRating.iconType,
            disabled: !featuredStore,
            ariaLabel: ratingType.toString()
        }), numericRating ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(RatingText, null, ratingType)) : /*#__PURE__*/ react.createElement(RatingText, null, ratingType), price ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : null, price && /*#__PURE__*/ react.createElement(price_information_PriceInformation, {
            price: price,
            stockStatus: stockStatus,
            isDeal: isDeal,
            featured: featuredStore
        }));
    };
    if (!pathname) {
        return /*#__PURE__*/ react.createElement(UnfeaturedStore, null, renderContent());
    }
    return /*#__PURE__*/ react.createElement(StoreLink, {
        "data-test": dataTest,
        onClick: trackClickOut,
        to: pathname,
        isExternal: renderMode === "native",
        target: "_blank"
    }, renderContent());
};


/***/ }),

/***/ 67209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ review_text)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/areas/reviews/review-context.tsx
var review_context = __webpack_require__(56132);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  img {\n    margin-top: 2px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin: ",
        " 0;\n  border-radius: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: none;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: pre-line;\n    word-break: break-word;\n    font-weight: 400;\n    color: ",
        ";\n    max-height: 5.7ex;\n    overflow: hidden;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 80ch;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: none;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n\n  &::after {\n    color: ",
        ";\n    content: '•';\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var TranslationOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptions",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.tertiary;
});
var TranslationOptionsService = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsService",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var TranslationOptionsToggle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsToggle",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Reply = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Reply",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ReplyName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyName",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var ReplyDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ReplyDate",
    componentId: "sc-0-5"
})(_templateObject5());
var ReplyText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyText",
    componentId: "sc-0-6"
})(_templateObject6());
var TextLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextLabel",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), function(p) {
        return p.theme.text.primary;
    }, props.fullText && (0,styled_components_browser_esm.css)(_templateObject7()));
});
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(_templateObject9());
var ReadMore = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ReadMore",
    componentId: "sc-0-9"
})(_templateObject10(), function(p) {
    return p.theme.text.linkExternal;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.linkExternalHover;
});
var Dates = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Dates",
    componentId: "sc-0-10"
})(_templateObject11(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Divider = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-11"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.quaternary;
});
var ReviewContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReviewContentWrapper",
    componentId: "sc-0-12"
})(_templateObject13());

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ReviewText = function(param) {
    var id = param.id, translation = param.translation, text = param.text, reply = param.reply;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onReviewExpansion = (0,review_context/* useReviewContext */.A)().onReviewExpansion;
    var ref = _slicedToArray((0,react.useState)(false), 2), showMore = ref[0], setShowMore = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), showOriginal = ref2[0], setShowOriginal = ref2[1];
    var textNode = (0,react.useCallback)(function(node) {
        if (node && node.parentElement) {
            var textHeight = node.getBoundingClientRect().height;
            var wrapperHeight = node.parentElement.getBoundingClientRect().height;
            setShowMore(textHeight > wrapperHeight);
        }
    }, []);
    var collapseOrExpand = isExpanded ? "symbol.collapse" : "symbol.expand";
    var reviewTextIdentifier = "review-text-".concat(id);
    var expansionText = isExpanded ? t("common", "button.show-less") : t("common", "button.show-more");
    var reviewText = showOriginal && translation ? translation.text : text;
    var toggleExpansion = function() {
        setIsExpanded(!isExpanded);
        if (onReviewExpansion) onReviewExpansion();
    };
    var toggleTranslation = function() {
        setShowOriginal(!showOriginal);
    };
    var renderTranslation = function() {
        if (!translation || !translation.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(TranslationOptions, null, /*#__PURE__*/ react.createElement(TranslationOptionsService, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "reviews"
        }, translation.service && translation.service.name ? "translation.translated-by-".concat(translation.service.name.toLowerCase(), ".md") : "translation.translated")), /*#__PURE__*/ react.createElement(TranslationOptionsToggle, null, /*#__PURE__*/ react.createElement("button", {
            type: "button",
            onClick: toggleTranslation
        }, showOriginal ? t("reviews", "translation.show-translation") : t("reviews", "translation.show-original"))));
    };
    var renderReply = function() {
        if (!reply || !reply.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(Reply, null, /*#__PURE__*/ react.createElement(ReplyName, null, t("reviews", "store.reply-by", {
            name: reply.name
        }), reply.date && /*#__PURE__*/ react.createElement(ReplyDate, null, reply.date)), /*#__PURE__*/ react.createElement(ReplyText, null, reply.text.trim()));
    };
    return /*#__PURE__*/ react.createElement(ReviewContentWrapper, null, /*#__PURE__*/ react.createElement(TextLabel, {
        id: reviewTextIdentifier,
        fullText: isExpanded
    }, /*#__PURE__*/ react.createElement(Text, {
        ref: textNode
    }, reviewText && reviewText.trim())), showMore && /*#__PURE__*/ react.createElement(ReadMore, {
        onClick: toggleExpansion,
        "aria-label": t("symbols", collapseOrExpand),
        "aria-expanded": isExpanded,
        "aria-controls": reviewTextIdentifier
    }, expansionText), translation && renderTranslation(), reply && renderReply());
};
/* harmony default export */ const review_text = (ReviewText);


/***/ }),

/***/ 55840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": () => (/* binding */ UserAvatarClickableStyle),
/* harmony export */   "SD": () => (/* binding */ UserAvatarStyle),
/* harmony export */   "ZT": () => (/* binding */ USER_AVATAR_SIZE),
/* harmony export */   "jP": () => (/* binding */ ReviewUserAvatar)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87172);
/* harmony import */ var src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40142);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42779);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var USER_AVATAR_SIZE = 32;
var UserAvatarStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__/* .UserAvatar */ .Y).withConfig({
    displayName: "UserAvatarStyle",
    componentId: "sc-0-0"
})(_templateObject());
var UserAvatarClickableStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_2__/* .Clickable */ .P).withConfig({
    displayName: "UserAvatarClickableStyle",
    componentId: "sc-0-1"
})(_templateObject1());
var ReviewUserAvatar = function(param) {
    var userId = param.userId, userAvatar = param.userAvatar, userDisplayName = param.userDisplayName, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), t = ref.t, market = ref.market, renderMode = ref.renderMode;
    var isRegisteredUser = Boolean(userId);
    var isRegisteredUserWithUsername = Boolean(userDisplayName && userId);
    var isExternalUser = !isRegisteredUser && Boolean(userDisplayName);
    var displayName = t("reviews", "user.guest");
    var avatar = "".concat(market.cdn, "/g/rfe/icons/anon-avatar.png");
    if (isRegisteredUserWithUsername || isExternalUser) {
        displayName = userDisplayName;
    }
    if (isRegisteredUserWithUsername) {
        avatar = userAvatar;
    }
    if (isExternalUser) {
        avatar = null;
    }
    var avatarProps = {
        avatar: avatar,
        displayName: displayName,
        size: USER_AVATAR_SIZE,
        isLinked: isRegisteredUser,
        unregisteredUser: Boolean(unregisteredUser),
        isFakeAccount: Boolean(isFakeAccount)
    };
    if (isRegisteredUser && !isFakeAccount) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarClickableStyle, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps)));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps));
};


/***/ }),

/***/ 36950:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ ReviewUsername)
/* harmony export */ });
/* unused harmony export UsernameStyle */
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5492);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66431);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87172);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42779);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10297);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 156px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var UsernameStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__/* .BodySmallText */ .oI).withConfig({
    displayName: "UsernameStyle",
    componentId: "sc-0-0"
})(_templateObject());
var checkRegistered = function(name, unregisteredUser, message) {
    return !unregisteredUser ? name : message;
};
var ReviewUsername = function(param) {
    var userId = param.userId, userDisplayName = param.userDisplayName, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), t = ref.t, renderMode = ref.renderMode;
    var usernameText = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(UsernameStyle, {
        container: "div",
        weight: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.HEAVIER */ .U9.HEAVIER,
        flex: false
    }, checkRegistered(userDisplayName, unregisteredUser, t("reviews", "user.unregistered")) || t("reviews", "user.guest"));
    if (userId && !isFakeAccount) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, usernameText);
    }
    return usernameText;
};


/***/ }),

/***/ 64318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ useReviewLikeHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3732);
/* harmony import */ var src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93302);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96328);




var selectLikedReviews = function(state) {
    var ref, ref1;
    return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : (ref1 = ref.likes) === null || ref1 === void 0 ? void 0 : ref1.reviews;
};
var useReviewLikeHandler = function(param) {
    var id = param.id, type = param.type;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var likedReviews = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(selectLikedReviews);
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__/* .useIsAuthenticated */ .k)();
    var liked = Boolean(likedReviews === null || likedReviews === void 0 ? void 0 : likedReviews.includes(id));
    var onLike = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (isAuthenticated) {
            dispatch((0,src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__/* .likeReviewToggle */ .eX)(id, type));
        }
    }, [
        dispatch,
        isAuthenticated,
        type,
        id
    ]);
    return {
        liked: liked,
        onLike: onLike
    };
};


/***/ }),

/***/ 15556:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ useReviewReportHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useReviewReportHandler = function(param) {
    var id = param.id;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), reportingReviewId = ref[0], setReportingReviewId = ref[1];
    var onReportIntent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(id);
    }, [
        id
    ]);
    var onReportCompleted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(null);
    }, []);
    return {
        reportingReviewId: reportingReviewId,
        onReportIntent: onReportIntent,
        onReportCompleted: onReportCompleted
    };
};


/***/ }),

/***/ 95846:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* binding */ useReviewViewedTracking)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
;// CONCATENATED MODULE: ./node_modules/.pnpm/observe-element-in-viewport@0.0.15/node_modules/observe-element-in-viewport/dist/index.esm.js
function o(o,r,t,e){if(void 0===t&&(t=function(){}),void 0===e&&(e={}),!o)throw new Error("Target element to observe should be a valid DOM Node");var n=Object.assign({},{viewport:null,modTop:"0px",modRight:"0px",modBottom:"0px",modLeft:"0px",threshold:[0]},e),i=n.viewport,a=n.modTop,u=n.modLeft,s=n.modBottom,f=n.modRight,d=n.threshold;if(!Array.isArray(d)&&"number"!=typeof d)throw new Error("threshold should be a number or an array of numbers");var h=Array.isArray(d)?d.map(function(o){return Math.floor(o%101)/100}):[Math.floor(d?d%101:0)/100],c=Math.min.apply(Math,h),m={root:i instanceof Node?i:null,rootMargin:a+" "+f+" "+s+" "+u,threshold:h},l=new IntersectionObserver(function(e,n){var i=e.filter(function(r){return r.target===o})[0],a=function(){return n.unobserve(o)};i&&(i.isInViewport=i.isIntersecting&&i.intersectionRatio>=c,i.isInViewport?r(i,a,o):t(i,a,o))},m);return l.observe(o),function(){return l.unobserve(o)}}var r=function(r,t){return void 0===t&&(t={}),new Promise(function(e,n){try{o(r,function(o,r){r(),e(!0)},function(o,r){r(),e(!1)},t)}catch(o){n(o)}})};
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/use-is-in-viewport@1.0.9_react@18.1.0/node_modules/use-is-in-viewport/built/index.esm.js
function index_esm_o(r){return"object"==typeof r&&"current"in r}function c(r){return"function"==typeof r&&"function"==typeof r.call}/* harmony default export */ function index_esm(i){void 0===i&&(i={});var f=(0,react.useState)(null),p=f[0],l=f[1],a=i.target,v=i.viewport,m=function(r,t){var n={};for(var e in r)Object.prototype.hasOwnProperty.call(r,e)&&-1===t.indexOf(e)&&(n[e]=r[e]);return n}(i,["target","viewport"]),w=(0,react.useRef)(null),y=(0,react.useRef)(null),b=(0,react.useCallback)(function(r){w.current=r,v&&(c(v)?v(r):index_esm_o(v)&&(v.current=r))},[w,v]),s=(0,react.useCallback)(function(r){y.current=r,a&&(c(a)?a(r):index_esm_o(a)&&(a.current=r))},[y,a]);return (0,react.useEffect)(function(){if(y.current)return o(y.current,function(){return l(!0)},function(){return l(!1)},Object.assign({},m,{viewport:w.current}))},[y.current,m,w]),[p,s,b]}
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/hooks/use-viewed-tracking.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useReviewViewedTracking = function(param) {
    var type = param.type;
    var userReviewRef = (0,react.useRef)(null);
    var ref = _slicedToArray(index_esm({
        target: userReviewRef
    }), 2), isInViewport = ref[0], reviewElementRef = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), reviewViewed = ref1[0], setReviewViewed = ref1[1];
    (0,react.useEffect)(function() {
        // Track viewed reviews
        if (isInViewport && !reviewViewed) {
            setReviewViewed(true);
            if (type === "store") {
                (0,tracking/* storeReviewViewed */.J8)();
            }
            if (type === "product") {
                (0,tracking/* productReviewViewed */.G0)();
            }
        }
    }, [
        type,
        isInViewport,
        reviewViewed
    ]);
    return {
        reviewElementRef: reviewElementRef
    };
};


/***/ }),

/***/ 83198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71406);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4012);
/* harmony import */ var _prisjakt_ui_icon_edit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56662);
/* harmony import */ var _prisjakt_ui_icon_flag_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92826);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5492);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64478);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93236);
/* harmony import */ var src_areas_reviews_components_prompt__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82951);
/* harmony import */ var src_areas_reviews_components_report__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62539);
/* harmony import */ var src_areas_store_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26474);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66431);
/* harmony import */ var src_components_like_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10849);
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32401);
/* harmony import */ var src_components_rating_smiley_rating_rating_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27424);
/* harmony import */ var src_components_rating_smiley_rating_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55776);
/* harmony import */ var src_components_shop_link_card__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46885);
/* harmony import */ var src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(24061);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96328);
/* harmony import */ var _components_review_text__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67209);
/* harmony import */ var _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(55840);
/* harmony import */ var _components_user_username__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36950);
/* harmony import */ var _hooks_use_like_handler__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(64318);
/* harmony import */ var _hooks_use_report_handler__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(15556);
/* harmony import */ var _hooks_use_viewed_tracking__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(95846);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(28127);


























var ShopUserReviewCard = function(param) {
    var className = param.className, id = param.id, text = param.text, rating = param.rating, reply = param.reply, replyDate = param.replyDate, createdAt = param.createdAt, updatedAt = param.updatedAt, createdAtFromNow = param.createdAtFromNow, updatedAtFromNow = param.updatedAtFromNow, userId = param.userId, userAvatar = param.userAvatar, userDisplayName = param.userDisplayName, userReviewCount = param.userReviewCount, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount, likes = param.likes, belongsTo = param.belongsTo, store = param.store, _showStore = param.showStore, showStore = _showStore === void 0 ? false : _showStore, isMyReview = param.isMyReview, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, viaShop = param.viaShop;
    var reviewElementRef = (0,_hooks_use_viewed_tracking__WEBPACK_IMPORTED_MODULE_24__/* .useReviewViewedTracking */ .$)({
        type: "store"
    }).reviewElementRef;
    var ref = (0,_hooks_use_report_handler__WEBPACK_IMPORTED_MODULE_23__/* .useReviewReportHandler */ .Q)({
        id: id
    }), reportingReviewId = ref.reportingReviewId, onReportIntent = ref.onReportIntent, onReportCompleted = ref.onReportCompleted;
    var ref1 = (0,_hooks_use_like_handler__WEBPACK_IMPORTED_MODULE_22__/* .useReviewLikeHandler */ .q)({
        id: id,
        type: "store"
    }), liked = ref1.liked, onLike = ref1.onLike;
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_18__/* .useIsAuthenticated */ .k)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_11__/* .AppContext */ .Il), t = ref2.t, renderMode = ref2.renderMode;
    var isMine = isMyReview && isAuthenticated;
    var currentReview = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return {
            id: id,
            rating: rating,
            reviewText: text
        };
    }, [
        id,
        rating,
        text
    ]);
    var reviewReply = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return {
            name: belongsTo.name,
            text: reply,
            date: replyDate
        };
    }, [
        belongsTo.name,
        reply,
        replyDate
    ]);
    var ratingObject = src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_13__/* ["default"].convert */ .Z.convert(rating || 0);
    var smileyRating = (0,src_components_rating_smiley_rating_utils__WEBPACK_IMPORTED_MODULE_15__/* .getSmileyRating */ .P)(ratingObject.rounded);
    var ratingText = t("reviews", smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text);
    if (!id) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, null, reportingReviewId ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(src_areas_reviews_components_report__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        review: reportingReviewId,
        onComplete: onReportCompleted,
        type: belongsTo.type
    }) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserReviewCard */ .IR, {
        className: className,
        containerProps: {
            "data-test": "UserReviewCard",
            "data-test-rating": rating,
            ref: reviewElementRef
        }
    }, store && showStore && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(src_components_shop_link_card__WEBPACK_IMPORTED_MODULE_16__/* .ShopLinkCard */ .E, {
        id: store.id,
        name: store.name,
        hasLogo: store.hasLogo,
        featured: store.featured,
        pathname: store.pathName,
        rating: store.userReviewSummary.rating,
        reviewCount: store.userReviewSummary.countTotal,
        renderMode: renderMode,
        logoUrl: store.logo,
        logoWidth: src_areas_store_constants__WEBPACK_IMPORTED_MODULE_10__/* .SHOP_LOGO_WIDTH */ .L9
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserInfo */ .ao, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_user_user_avatar__WEBPACK_IMPORTED_MODULE_20__/* .ReviewUserAvatar */ .jP, {
        userId: userId,
        userAvatar: userAvatar,
        userDisplayName: !unregisteredUser ? userDisplayName : t("reviews", "user.unregistered"),
        unregisteredUser: unregisteredUser,
        isFakeAccount: isFakeAccount
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserInfoRow */ .f9, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_user_username__WEBPACK_IMPORTED_MODULE_21__/* .ReviewUsername */ .n, {
        userId: userId,
        userDisplayName: userDisplayName,
        unregisteredUser: unregisteredUser,
        isFakeAccount: isFakeAccount
    }), userReviewCount && userReviewCount > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .Divider */ .iz, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserInfoText */ .Wn, {
        $bold: true
    }, t("reviews", "user.total-reviews", {
        n: userReviewCount
    }))) : null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserInfoRow */ .f9, null, rating && smileyRating ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(src_components_rating_smiley_rating_rating_icon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        type: smileyRating.iconType,
        ariaLabel: ratingText,
        disabled: false
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__/* .BodySmallText */ .oI, {
        flex: false
    }, ratingText)) : null, createdAt || updatedAt ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .UserInfoText */ .Wn, {
        containerProps: {
            title: createdAt
        }
    }, updatedAt && t("reviews", "info.edited", {
        date: updatedAtFromNow || updatedAt
    }), !updatedAt && createdAt && t("reviews", "info.created", {
        date: createdAtFromNow || createdAt
    })) : null, viaShop && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .ViaShop */ .zH, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .ViaShopTooltip */ .iK, {
        placement: src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_17__/* .TooltipPlacement.TOP */ .TQ.TOP,
        title: t("reviews", "store.via-shop-tooltip")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_1__/* .IconInfoFilled */ .h, {
        size: 16,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .ViaShopText */ .g0, null, t("reviews", "store.via-shop")))))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .Review */ .Cq, null, Boolean(text) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_review_text__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        id: id,
        text: text,
        reply: reviewReply
    })), showFooter ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .Footer */ .$_, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .FooterContent */ .Bp, null, likes && isMine ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .Statistic */ .$k, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .ThumbsUpIcon */ .lb, {
        size: 16
    }), " ", likes) : null, isMine ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .Edit */ .I8, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(src_areas_reviews_components_prompt__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        belongsTo: belongsTo,
        currentReview: currentReview,
        store: store,
        control: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_0__/* .TextButton */ .Av, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_0__/* .ButtonIcon */ .Ei, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_icon_edit__WEBPACK_IMPORTED_MODULE_2__/* .IconEdit */ .y, null)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_0__/* .ButtonText */ .oD, null, t("common", "button.edit")))
    })) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(src_components_like_button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        onClick: onLike,
        liked: liked,
        likes: likes,
        size: _styles__WEBPACK_IMPORTED_MODULE_25__/* .ICON_SIZE */ .ZG
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_styles__WEBPACK_IMPORTED_MODULE_25__/* .ReportButton */ .f4, {
        onClick: onReportIntent
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
        placement: _prisjakt_ui__WEBPACK_IMPORTED_MODULE_6__/* .Direction.Left */ .Nm.Left,
        title: t("feedback", "report-review.title")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createElement(_prisjakt_ui_icon_flag_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconFlagOutlined */ .b, {
        size: 20
    })))))) : null));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.memo)(ShopUserReviewCard));


/***/ }),

/***/ 28127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ Footer),
/* harmony export */   "$k": () => (/* binding */ Statistic),
/* harmony export */   "Bp": () => (/* binding */ FooterContent),
/* harmony export */   "Cq": () => (/* binding */ Review),
/* harmony export */   "I8": () => (/* binding */ Edit),
/* harmony export */   "IR": () => (/* binding */ UserReviewCard),
/* harmony export */   "Wn": () => (/* binding */ UserInfoText),
/* harmony export */   "ZG": () => (/* binding */ ICON_SIZE),
/* harmony export */   "ao": () => (/* binding */ UserInfo),
/* harmony export */   "f4": () => (/* binding */ ReportButton),
/* harmony export */   "f9": () => (/* binding */ UserInfoRow),
/* harmony export */   "g0": () => (/* binding */ ViaShopText),
/* harmony export */   "iK": () => (/* binding */ ViaShopTooltip),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "lb": () => (/* binding */ ThumbsUpIcon),
/* harmony export */   "zH": () => (/* binding */ ViaShop)
/* harmony export */ });
/* unused harmony exports FooterLink, ExternalPartner, EyeIcon */
/* harmony import */ var _prisjakt_ui_icon_eye__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41093);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79514);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5492);
/* harmony import */ var _prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5521);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33399);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87172);
/* harmony import */ var src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48892);
/* harmony import */ var src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24061);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10297);
/* harmony import */ var _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55840);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: none;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      > div {\n        width: unset !important;\n        > img {\n          width: 12px !important;\n          height: 12px !important;\n        }\n      }\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.4rem;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  &::after {\n    color: ",
        ";\n    content: '|';\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    line-height: 1.33333;\n    opacity: 1;\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: ",
        ";\n\n  p {\n    margin: 0;\n  }\n\n  a {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  ",
        ", ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n    align-self: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  gap: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  position: relative;\n  font-weight: 600;\n\n  &:not(:last-of-type) {\n    margin-right: ",
        ";\n  }\n\n  ",
        ", ",
        " {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: auto;\n\n  path {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    cursor: pointer;\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}










var ICON_SIZE = 20;
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(_templateObject());
var FooterContent = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "FooterContent",
    componentId: "sc-0-1"
})(_templateObject1());
var FooterLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .BodySmallText */ .oI).withConfig({
    displayName: "FooterLink",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Edit = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Edit",
    componentId: "sc-0-3"
})(_templateObject3());
var ExternalPartner = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .BodySmallText */ .oI).withConfig({
    displayName: "ExternalPartner",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.base400;
});
var UserReviewCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg).withConfig({
    displayName: "UserReviewCard",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject5(), p.$expanded ? "margin: 0 ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";") : "\n    &:first-child {\n      margin-left: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";\n    }\n\n    &:last-child {\n      margin-right: ").concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";\n    }\n    "));
});
var UserInfoRow = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "UserInfoRow",
    componentId: "sc-0-6"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject7(), src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__/* .StarsWrapper */ .gL));
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.text.quaternary;
});
var UserInfoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .CaptionText */ .HB).withConfig({
    displayName: "UserInfoText",
    componentId: "sc-0-8"
})(_templateObject10(), function(p) {
    return p.$bold ? p.theme.colors.base500 : p.theme.colors.base400;
});
var UserInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "UserInfo",
    componentId: "sc-0-9"
})(_templateObject11(), _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .USER_AVATAR_SIZE */ .ZT, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.callToActionHover;
}, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .UserAvatarStyle */ .SD, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .UserAvatarClickableStyle */ .$t);
var Review = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg).withConfig({
    displayName: "Review",
    componentId: "sc-0-10"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ViaShop = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "ViaShop",
    componentId: "sc-0-11"
})(_templateObject13(), function(p) {
    return p.theme.colors.maybeBlue700;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
var ViaShopTooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u).withConfig({
    displayName: "ViaShopTooltip",
    componentId: "sc-0-12"
})(_templateObject14());
var ViaShopText = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].span.withConfig({
    displayName: "ViaShopText",
    componentId: "sc-0-13"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ThumbsUpIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconLikeFilled */ .G).withConfig({
    displayName: "ThumbsUpIcon",
    componentId: "sc-0-14"
})(_templateObject16(), function(p) {
    return p.theme.text.primary;
});
var EyeIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_icon_eye__WEBPACK_IMPORTED_MODULE_0__/* .IconEye */ .t).withConfig({
    displayName: "EyeIcon",
    componentId: "sc-0-15"
})(_templateObject17(), function(p) {
    return p.theme.text.primary;
});
var Statistic = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Statistic",
    componentId: "sc-0-16"
})(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ThumbsUpIcon, EyeIcon, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ReportButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_5__/* .Clickable */ .P).withConfig({
    displayName: "ReportButton",
    componentId: "sc-0-17"
})(_templateObject19(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
});


/***/ }),

/***/ 55189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useReviewsData)
/* harmony export */ });
/* unused harmony export SortOptions */
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_mergeWith__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53038);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var SortOptions;
(function(SortOptions) {
    SortOptions["MOST_HELPFUL"] = "like_score";
    SortOptions["RECENT"] = "date_with_local_prio";
})(SortOptions || (SortOptions = {}));
var reducer = function(state, newState) {
    return _objectSpread({}, state, newState);
};
/**
 * Fetches reviews using the provided query, and exposes functions for fetching
 * the next page of reviews as well as refetching when the filter or sort order
 * changes.
 */ var useReviewsData = function(param) {
    var query = param.query, limit = param.limit, variables = param.variables, nextPageVariables = param.nextPageVariables, _initialData = param.initialData, initialData = _initialData === void 0 ? null : _initialData, initialSort = param.initialSort;
    var fetchContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    // Prettier completely mangles the generics on this line...
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, {
        fetching: false,
        showLoader: true,
        data: initialData,
        errors: null,
        offset: 0,
        sort: initialSort,
        filter: "ALL"
    }), 2), state = ref[0], setState = ref[1];
    var run = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var response;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setState({
                        data: null,
                        errors: null,
                        fetching: true,
                        showLoader: true,
                        offset: state.offset
                    });
                    return [
                        4,
                        fetchContext.query(query, _objectSpread({
                            offset: state.offset,
                            userReviewLimit: limit,
                            userReviewSort: state.sort,
                            userReviewFilter: state.filter
                        }, variables, nextPageVariables === null || nextPageVariables === void 0 ? void 0 : nextPageVariables(null)))
                    ];
                case 1:
                    response = _state.sent();
                    setState({
                        data: response.data,
                        fetching: false,
                        showLoader: false
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchContext,
        query,
        state,
        limit,
        variables,
        nextPageVariables
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!state.fetching && !state.data && query !== "") {
            run();
        }
    }, [
        query,
        run,
        state.data,
        state.fetching
    ]);
    var fetchMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var newOffset, ref, data, errors, newData;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (state.fetching) {
                        return [
                            2
                        ];
                    }
                    setState({
                        fetching: true
                    });
                    newOffset = state.offset + limit;
                    return [
                        4,
                        fetchContext.query(query, _objectSpread({
                            offset: newOffset,
                            userReviewLimit: limit,
                            userReviewSort: state.sort,
                            userReviewFilter: state.filter
                        }, variables, nextPageVariables === null || nextPageVariables === void 0 ? void 0 : nextPageVariables(state.data)))
                    ];
                case 1:
                    ref = _state.sent(), data = ref.data, errors = ref.errors;
                    newData = lodash_mergeWith__WEBPACK_IMPORTED_MODULE_0___default()({}, state.data, data, function(objValue, srcValue, key) {
                        if (key === "nodes" && Array.isArray(objValue)) {
                            return objValue.concat(srcValue);
                        }
                        return undefined;
                    });
                    setState({
                        offset: newOffset,
                        fetching: false,
                        data: newData,
                        errors: errors
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchContext,
        query,
        state.data,
        state.fetching,
        state.offset,
        state.sort,
        state.filter,
        limit,
        variables,
        nextPageVariables
    ]);
    var onSortChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = _asyncToGenerator(function(sortOption) {
            var ref, data, errors;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (state.fetching) {
                            return [
                                2
                            ];
                        }
                        setState({
                            fetching: true,
                            sort: sortOption
                        });
                        return [
                            4,
                            fetchContext.query(query, _objectSpread({
                                offset: 0,
                                userReviewLimit: limit + state.offset,
                                userReviewSort: sortOption,
                                userReviewFilter: state.filter
                            }, variables))
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, errors = ref.errors;
                        setState({
                            data: data,
                            errors: errors,
                            fetching: false
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(sortOption) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetchContext,
        query,
        state.fetching,
        state.offset,
        state.filter,
        limit,
        variables
    ]);
    var onFilterChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = _asyncToGenerator(function(filter) {
            var ref, data, errors;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (state.fetching) {
                            return [
                                2
                            ];
                        }
                        setState({
                            fetching: true,
                            filter: filter
                        });
                        return [
                            4,
                            fetchContext.query(query, _objectSpread({
                                offset: 0,
                                userReviewLimit: limit + state.offset,
                                userReviewSort: state.sort,
                                userReviewFilter: filter
                            }, variables))
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, errors = ref.errors;
                        setState({
                            data: data,
                            errors: errors,
                            fetching: false
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetchContext,
        query,
        state.fetching,
        state.offset,
        state.sort,
        limit,
        variables
    ]);
    return _objectSpreadProps(_objectSpread({}, state), {
        fetchMore: fetchMore,
        onSortChange: onSortChange,
        onFilterChange: onFilterChange
    });
};


/***/ }),

/***/ 35883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ ListMobileColumnElseRow),
/* harmony export */   "U": () => (/* binding */ ColumnWithGutter)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var _prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33024);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79514);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33399);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ColumnWithGutter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .sg).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ListMobileColumnElseRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__/* .List */ .a).withConfig({
    displayName: "ListMobileColumnElseRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumUp */ .BC.mediumUp(_templateObject1()));


/***/ }),

/***/ 45052:
/***/ ((module) => {

module.exports = "query shopReviews($id: Int!, $offset: Int!, $userReviewLimit: Int = 10, $userReviewSort: String = \"date\", $userReviewFilter: ReviewFilter = ALL, $invalidateCache: Boolean = false, $getProduct: Boolean = false, $getStore: Boolean = false) {\n  store(id: $id) {\n    ...storeUserReviews\n  }\n}\n\nfragment storeUserReviews on Store {\n  userReviewSummary {\n    rating\n    count\n    countTotal\n    distribution\n    distributionNew {\n      score\n      count\n      percentage\n    }\n  }\n  userReviews(\n    offset: $offset\n    limit: $userReviewLimit\n    sort: $userReviewSort\n    filter: $userReviewFilter\n    invalidateCache: $invalidateCache\n  ) {\n    myReview {\n      id\n      rating\n      reviewText\n      createdAt\n      localizedCreatedAt: createdAt(format: \"L\")\n      localizedUpdatedAt: updatedAt(format: \"L\")\n    }\n    pageInfo {\n      offset\n      limit\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...GenericUserReview\n      reply\n      replyDate\n      translation {\n        text: reviewText\n        language\n        service {\n          name\n          uri\n        }\n      }\n      verifiedPurchase\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  user {\n    id\n    name\n    displayName\n    reviewCount\n    unregistered\n    isFakeAccount\n    avatar(width: _100)\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ })

}]);